export default {
  general: {
    activate: 'Attiva',
    add: 'Aggiungi',
    any: 'Qualunque',
    avatar: 'Avatar',
    apply: 'Applica',
    access_level: 'Livello di accesso',
    app_user_settings: 'Impostazioni app e utente',
    amount: 'Quantità',
    all: 'Tutto',
    all_tags: 'Tutte le etichette',
    assignees: 'Assegnatari',
    add_favorite: 'Aggiungi preferito',
    add_user: 'Aggiungi utente | Aggiungi utenti',
    add_tag: 'Aggiungi etichetta | Aggiungi etichette',
    add_task: 'Aggiungi attività | Aggiungi attività',
    add_group: 'Aggiungi gruppo | Aggiungi gruppi',
    add_phase: 'Aggiungi fase | Aggiungi fasi',
    add_account: 'Aggiungi account | Aggiungi account',
    add_to_group: 'Aggiungi al gruppo',
    add_to_projects: 'Aggiungi ai progetti',
    add_projects_to_users: 'Aggiungi tutti gli utenti selezionati ai progetti',
    add_users_to_group: 'Aggiungi tutti gli utenti selezionati a un gruppo',
    add_new: 'Aggiungi nuovo',
    add_time: 'Aggiungi tempo',
    archived: 'Archiviato | Archiviato',
    active: 'Attivo',
    archive: 'Archivio',
    archive_clients: 'Archiviare i clienti',
    assigned_to: 'Assegnato a',
    additional_info: 'Informazioni supplementari',
    an_unexpected_error_occurred: 'Si è verificato un errore imprevisto.',
    billed: 'Fatturato',
    billable: 'Fatturabile',
    billing_status: 'Stato della fatturazione',
    budget_amount: 'Importo del budget',
    bill_by_hour: 'Fatturazione oraria, con tariffe fatturabili',
    bill_a_set_price: 'Fattura un prezzo fisso, indipendentemente dal tempo tracciato',
    billing: 'Fatturazione',
    bulk_edit: 'Modifica collettiva {number} {el}',
    budget: 'Budget | Budget',
    billed_expenses: 'Spese fatturate',
    billed_time: 'Tempo fatturato',
    close: 'Chiudi',
    board: 'Bacheca',
    clear_filters: 'Cancella filtri',
    change_account: 'Cambia account',
    change: 'Modifica',
    configuration: 'Configurazione',
    category: 'Categoria | Categorie',
    client: 'Cliente | Clienti',
    click_to_add: 'Clicca qui per aggiungerne uno nuovo.',
    cost: 'Costo | Costi',
    confirm: 'Confermare',
    calendar: 'Calendario',
    creation_date: 'Data di creazione',
    cancel: 'Annulla',
    color: 'Colore',
    client_id: 'Identificativo cliente',
    common: 'Comune',
    changes_need_saved: 'Le modifiche devono essere salvate',
    create: 'Crea',
    create_new_expense_category: 'Crea una nuova categoria di spesa',
    create_new_project: 'Crea nuovo progetto',
    copy: 'Copia',
    country: 'Paese | Paesi',
    current_value_out_of_total_value: '{current_value} su {total_value}',
    currency_per_hour: '{currency}/ora',
    custom: 'Personalizza',
    copy_phase_from: 'Copia fasi da...',
    change_calendar: 'Cambia calendario',
    choose_calendar: 'Scegli il calendario da cui desideri importare i tuoi eventi',
    deactivate: 'Disattiva',
    deactivated: 'Disattivato',
    deactivated_element: 'Elemento disattivato',
    date: 'Data',
    day: 'Giorno | 1 giorno | {number} giorni',
    deleted: 'Eliminato | Eliminato',
    deleted_entry: 'Registrazione eliminata',
    deleted_timer: 'Timer eliminato',
    deleted_suggestion: 'Suggerimento eliminato',
    delete: 'Elimina',
    delete_confirmation_report: 'Vuoi eliminare questo report?',
    dismiss: 'Annulla',
    done: 'Fatto',
    dpa: 'Accordo sul trattamento dei dati',
    drop_image_here: 'Rilascia la tua immagine qui',
    drop_your_image: 'Rilascia la tua immagine ovunque o fai clic qui per selezionarla dal tuo dispositivo',
    delete_element_alert: '| Stai per eliminare {name} | Stai per eliminare {number} {element}',
    description: 'Descrizione',
    due_date: 'Scadenza',
    e_mail: 'E-mail | E-mail',
    entries_log: 'Elenco registrazioni',
    expense: 'Spesa | Spese',
    expense_category: 'Categoria di spesa | Categorie di spesa',
    expense_deletion: 'Cancellazione spese',
    edit: 'Modifica',
    export: 'Esporta',
    edit_tag_list: 'Modifica gruppo etichette',
    entry: 'Registrazione | Registrazioni',
    estimate: 'Stima',
    field_required: 'Campo obbligatorio',
    filters: 'Filtri',
    fixed_fee: 'Tariffa fissa',
    from: 'Da',
    get_started: 'Inizia',
    group: 'Gruppo | Gruppi',
    has_been_archived: 'La fase/progetto collegato è stato archiviato oppure potresti essere stato rimosso dal progetto.',
    has_been_updated: '{el} è stato aggiornato',
    help_desk: 'Help Desk',
    hourly: 'Ogni ora',
    hourly_rate: 'Tariffa oraria',
    hourly_cost: 'Costo orario',
    job_title: 'Titolo di lavoro',
    keyboard_shortcuts: 'Tasti rapidi',
    import_from_ms: 'Importa da MS To Do',
    integration: 'Integrazione | Integrazioni',
    learn_more: 'Scopri di più',
    login: 'Login',
    light: 'Leggero',
    leave_unchanged: 'Lascia invariato',
    locked_entry: 'Registrazione bloccata.',
    lock: 'Blocca',
    list: 'Elenco',
    legacy: 'Vecchio stile',
    labour_costs: 'Costo del lavoro',
    last_sync: 'Ultima sincronizzazione {el}',
    load_more: 'Carica altro',
    loading_integration: 'Caricamento integrazione...',
    linked_project_api_only: {
      body: 'Il progetto collegato è {0} e la registrazione può essere modificata solo tramite API.',
      api_only: 'Solo API'
    },
    manager: 'Supervisore | Supervisori',
    member: 'Membro | Membri',
    manage: 'Gestisci',
    me: 'me',
    menu: 'Menu',
    manage_integration: 'Gestisci integrazione | Gestisci integrazioni',
    my_tasks: 'Le mie attività',
    monetary_budget: 'Budget monetario',
    multiple_new_projects: 'Più nuovi progetti con modello',
    new_project: 'Nuovo progetto',
    new_team_members: 'Nuovi membri del team',
    no_data: 'Nessun dato',
    no_budget: 'Nessun budget',
    no_data_for: 'Nessun dato per il periodo corrente',
    none: 'Nessuno',
    note: 'Nota | Note',
    name: 'Nome | Nomi',
    notifications: 'Notifiche',
    notes_and_integration_info: 'Note e informazioni sull\'integrazione',
    no_tags: 'Nessuna etichetta',
    not_assigned: 'Non assegnato',
    no_data_available: 'Nessun dato disponibile',
    not_billable: 'Non fatturabile',
    non_billable: 'Non fatturabile',
    not_billable_to_client: 'Non fatturato a un cliente',
    no_data_found: 'Nessun dato trovato',
    n_a: 'N / A',
    number_member_selected: '{number} membri selezionati | Un membro selezionato | {number} membri selezionati',
    number_category_selected: '{number} categoria selezionata | Una categoria selezionata | {number} categoria selezionata',
    number_expense_category_selected: '{number} categoria di spesa selezionata | Una categoria di spesa selezionata | {number} categoria di spesa selezionata',
    number_tag_selected: '{number} etichetta selezionate | Una etichetta selezionata | {number} etichette selezionate',
    number_tag_list_selected: '{number} gruppo di etichette selezionato | Un gruppo di etichette selezionato | {number} gruppi di etichette selezionati',
    number_todo_selected: '{number} attività selezionata | Un\'attività selezionata | {number} attività selezionata',
    number_todo_list_selected: '{number} elenco attività selezionato | Un elenco attività selezionato | {number} elenchi attività selezionati',
    number_country_selected: '{number} paese selezionato | Un paese selezionato | {number} paese selezionato',
    number_external_selected: '{number} esterno selezionato | Un esterno selezionato | {number} esterno selezionato',
    number_user_selected: '{number} utenti selezionati | Un utente ha selezionato | {number} utenti selezionati',
    number_group_selected: '{number} gruppo selezionato | Un gruppo selezionato | {number} gruppo selezionato',
    number_user_updated: '{number} utenti aggiornati | Un utente aggiornato | {number} utenti aggiornati',
    number_client_selected: '{number} clienti selezionati | Un cliente selezionato | {number} clienti selezionati',
    number_client_unarchived: '{number} clienti ripristinati | Un cliente ripristinato | {number} clienti ripristinati',
    number_expense_selected: '{number} spese selezionate | Una spesa selezionata | {number} spese selezionate',
    number_project_selected: '{number} progetti selezionati | Un progetto selezionato | {number} progetti selezionati',
    number_project_updated: '{number} progetti aggiornati | Un progetto aggiornato | {number} progetti aggiornati',
    number_project_deleted: '{number} progetti eliminati | Un progetto eliminato | {number} progetti eliminati',
    import_data: 'Importa dati',
    import_from: 'Importare da',
    insert_password: 'Inserisci la password',
    integration_info: 'Informazioni sull\'integrazione',
    info: 'Informazioni',
    in_progress: 'In corso',
    or: 'oppure',
    please_check_filters: 'Controlla i filtri e riprova',
    public: 'Pubblico',
    password: 'Password',
    phone_number: 'Numero di telefono',
    this_should_be_phone_number: 'Questo dovrebbe essere un numero di telefono',
    priority: 'Priorità',
    project: 'Progetto | Progetti',
    project_hourly_rate: 'Tariffa oraria del progetto',
    project_hourly_rate_required_for: 'La tariffa oraria del progetto è necessaria per calcolare il valore monetario del tuo tempo e mantenere aggiornato il budget del progetto',
    phase: 'Fase | Fasi',
    phase_category: 'Categoria di fase | Categorie di fase',
    product: 'Prodotto',
    pre_select_projects: 'Preseleziona i progetti per gli eventi importati',
    passwords_do_not_match: 'Le password non corrispondono',
    personal_access_tokens: 'Token di accesso personali',
    project_with_no_tags: 'Questo progetto non ha etichette.',
    progress: 'Progresso',
    project_budget: 'Budget del progetto',
    project_fee: 'Commissione del progetto',
    report: 'Report | Report',
    required: 'Necessario',
    read_article: 'Leggi l\'articolo',
    required_at_least_one_tag: 'Richiedi almeno una etichetta per ogni registrazione',
    reload: 'Ricaricare',
    repeat_password: 'Ripeti la password',
    remove: 'Rimuovere',
    remove_favorite: 'Rimuovi preferito',
    register_time: 'Registra il tempo',
    report_delete_advertisment: 'Dopo la conferma ogni automazione associata a questo report verrà eliminata',
    report_delete_error: 'Si è verificato un problema durante l\'eliminazione di questo report.',
    required_field: 'Campo obbligatorio',
    revenue: 'Ricavo',
    timesheet: 'Foglio ore | Fogli ore',
    time_spent: 'Tempo impiegato',
    update_password: 'Aggiorna password',
    updating_your_password: 'Aggiornamento della password...',
    un_archive: 'Ripristina',
    unit_price: 'Prezzo unitario',
    update: 'Aggiorna',
    updated: 'Aggiornato | Aggiornato',
    updated_last_project: 'Progetto aggiornato',
    user: 'Utente | Utenti',
    user_deactivated: 'Utente disattivato.',
    undo_deletion: 'Annulla l\'eliminazione',
    unknown_phase: 'Fase sconosciuta',
    users_will_not_be_able_track_time: 'Gli utenti non saranno in grado di etichettare le proprie registrazioni',
    users_will_be_able_to_tag_any_tag: 'Gli utenti potranno etichettare le proprie registrazioni con qualsiasi etichetta dell\'account',
    users_will_be_able_to_tag_selected_tag_list: 'Gli utenti potranno etichettare le proprie registrazioni solo con i gruppi di etichette selezionati',
    unarchived: 'Ripristinato',
    unbilled_expenses: 'Spese non fatturate',
    unbilled: 'Non fatturato',
    unbilled_time: 'Tempo non fatturato',
    unbilled_money: 'Importo non fatturato',
    unbilled_explain: 'Importo non fatturato = manodopera non fatturata + spese non fatturate + tariffa fissa non fatturata',
    updated_data: 'Alcuni dati sono cambiati rispetto al caricamento dell\'ultima pagina',
    start_timer: 'Avvia il timer',
    save_entry: 'Salva registrazione',
    sync_private_appointments: 'Sincronizza gli appuntamenti privati',
    set_hourly_rate: 'Imposta la tariffa oraria',
    set_hourly_cost: 'Imposta il costo orario',
    set_expense_lock: 'Imposta il blocco delle spese',
    set_billing_status: 'Imposta lo stato di fatturazione',
    select_tags: 'Seleziona etichetta | Seleziona etichette',
    select_assignees: 'Seleziona gli assegnatari',
    select_status: 'Seleziona lo stato',
    select_priority: 'Seleziona la priorità',
    start_date: 'Data d\'inizio',
    sla: 'SLA',
    save: 'Salva',
    show: 'Mostra',
    sort_by: 'Ordina per',
    full_name: 'Nome e cognome',
    search_within_expense_categories: 'Cerca all\'interno delle categorie di spesa',
    start_tracking_time: 'Inizia a monitorare il tempo',
    select_all: 'Seleziona tutto',
    select_calendar: 'Seleziona un calendario',
    set_access_level: 'Imposta il livello di accesso',
    set_access_level_user: 'Imposta il livello di accesso per tutti gli utenti selezionati',
    seconds: 'Secondi',
    team: 'Squadra | Squadre',
    tag: 'Etichetta | Etichette',
    to: 'A',
    total: 'Totale | Totali',
    time: 'Tempo',
    timer: 'Timer | Timer',
    tag_list: 'Gruppo di etichette | Gruppi di etichette',
    tag_lists: 'Gruppi di etichette',
    todo_list: 'Elenco delle attività',
    task: 'Attività | Attività',
    task_list: 'Elenco delle attività',
    time_worked: 'Tempo lavorato',
    total_time: 'Tempo totale',
    total_cost: 'Costo totale',
    total_revenues: 'Entrate totali',
    total_billed: 'Totale fatturato',
    terms_conditions: 'Termini & Condizioni',
    team_member: 'Membro della squadra | Membri del team',
    timer_started: 'Il timer è iniziato.',
    timer_saved: 'Timer salvato.',
    timer_paused: 'Il timer è stato messo in pausa',
    time_budget: 'Budget temporale',
    time_tracked: 'Tempo monitorato',
    timezone: 'Fuso orario',
    timeframe: 'Lasso di tempo',
    table_configuration: 'Configurazione della tabella',
    tag_lists_and_tags: 'Gruppi di etichette & etichette',
    time_and_material: 'Tempo & Materiale',
    url: 'URL',
    optional: 'opzionale',
    optional_notes: 'Note facoltative per riferimento',
    overview: 'Panoramica',
    other: 'Altro | Altri',
    you_are_about_to_add_element: 'Stai per aggiungere <b>{number} {first_el} a {article} {second_el}</b>.<br/> Questa azione richiede conferma',
    working_time: 'Orario di lavoro',
    without_element: 'Senza {el}',
    watch_the_video: 'Guarda il video',
    workspace_settings: 'Impostazioni dell\'account',
    why_this_field_required: 'Perché questo campo è obbligatorio?',
    webhooks: 'Webhook',
    weekly: 'Ogni settimana',
    biweekly: 'Ogni 2 settimane',
    monthly: 'Ogni mese',
    entry_locked_by_approval: 'Questa registrazione è già stata approvata e non può essere modificata.',
    all_entries_older: 'Tutte le registrazioni precedenti a {0} sono bloccate e possono essere modificate solo dagli amministratori.',
    all_dates_older: 'Tutte le date precedenti a {0} sono bloccate e non possono essere usate per creare nuove registrazioni/timers.',
    date_locked_by_approval: 'Questa data fa parte di un periodo approvato e non può essere usata per creare nuove registrazioni/timers.',
    create_webhook: 'Crea Webhook',
    edit_webhook: 'Modifica Webhook',
    webhook_url: 'URL del Webhook',
    webhook_secret: 'Segreto del Webhook',
    events: 'Eventi',
    webhook_logs: 'Log del Webhook',
    event: 'Evento',
    payload: 'Payload',
    status: 'Stato',
    delivered_at: 'Consegnato il',
    attempts: 'Tentativi',
    saved_successfully: 'Salvato con successo',
    phases_updated: 'Fasi aggiornate correttamente'
  },
  access_levels: {
    admin: 'Amministratore | Amministratori',
    owner: 'Proprietario | Proprietari',
    member: 'Membro | Membri',
    pm: 'PM | PMs',
    gm: 'GM | GMs',
    direct_manager: 'Manager Diretto',
    all_managers: 'Tutti i manager'
  },
  priorities: {
    low: 'Bassa',
    medium: 'Media',
    high: 'Alta'
  },
  timeframe: {
    all_time: 'Sempre',
    custom: 'Personalizzato',
    hours: 'Ore',
    never: 'Mai',
    day: 'Giorno | Giorni',
    daily: 'giornaliero',
    week: 'Settimana',
    weekly: 'ogni settimana',
    month: 'Mese',
    monthly: 'ogni mese',
    day_of_week: 'Giorno della settimana',
    day_of_month: 'Giorno del mese',
    invalid_day: 'Giorno non valido',
    weekends: 'Fine settimana',
    time: 'Tempo',
    today: 'Oggi',
    yesterday: 'Ieri',
    this_week: 'Questa settimana',
    this_month: 'Questo mese',
    this_year: 'Quest\'anno',
    last_week: 'La settimana scorsa',
    last_month: 'Lo scorso mese',
    last_7_days: 'Ultimi 7 giorni',
    last_15_days: 'Ultimi 15 giorni',
    last_30_days: 'Ultimi 30 giorni',
    last_3_months: 'Ultimi 3 mesi',
    last_6_months: 'Ultimi 6 mesi',
    last_12_months: 'Ultimi 12 mesi'
  },
  days: {
    monday: 'Lunedì',
    tuesday: 'Martedì',
    wednesday: 'Mercoledì',
    thursday: 'Giovedì',
    friday: 'Venerdì',
    saturday: 'Sabato',
    sunday: 'Domenica'
  },
  entries: {
    updated_entry: 'Registrazione aggiornata',
    entry_copied: 'Registrazione copiata.',
    to_filter_phases_select_project: 'Per filtrare per fasi è necessario selezionare un singolo progetto'
  },
  timer: {
    pause: 'Pausa',
    start: 'Inizio',
    save_as_an_entry: 'Salva come registrazione',
    updated_last_timer: 'Timer aggiornato',
    timer_paused: 'Il timer è stato messo in pausa',
    timer_started: 'Il timer è partito',
    timer_saved_as_entry: 'Timer salvato come registrazione.'
  },
  suggestion: {
    accept: 'Accettare',
    ignore: 'Ignora',
    suggestion_accepted: 'Suggerimento accettato e salvato come registrazione.',
    suggestion: 'Nessun suggerimento | 1 Suggerimento | {el} suggerimenti'
  },
  tasks: {
    assigned_to_me: 'Assegnato a me'
  },
  roles: {
    accountant: 'Contabile',
    business_development_professional: 'Professionista dello sviluppo aziendale',
    business_owner_or_founder: 'Imprenditore o fondatore',
    customer_service_representative: 'Rappresentante del Servizio Clienti',
    data_science_engineer: 'Ingegnere di scienza dei dati',
    designer: 'progettista',
    devOps_engineer: 'Ingegnere DevOps',
    facilities_manager: 'Manager delle infrastrutture',
    financial_advisor: 'Consulente finanziario',
    fitness_coach: 'Istruttore di fitness',
    group_manager: 'Gestore del gruppo',
    gm: 'Manager del gruppo',
    health_professional: 'Professionista della salute',
    human_resources_professional: 'Professionista delle risorse umane',
    information_technology_rofessional: 'Professionista dell\'informatica',
    legal_professional: 'Professionista legale',
    marketer: 'Venditore',
    mechanical_engineer: 'Ingegnere meccanico',
    office_manager: 'Capo ufficio',
    operations_professional: 'Professionista delle operazioni',
    pm: 'PM',
    personal_assistant: 'Assistente personale',
    president_or_ceo: 'Presidente o amministratore delegato',
    product_manager: 'Responsabile del prodotto',
    project_manager: 'Responsabile del progetto',
    property_manager: 'Gestore della proprietà',
    public_relations_professional: 'Professionista delle pubbliche relazioni',
    real_estate_agent: 'Agente immobiliare',
    recruiter: 'Reclutatore',
    salesperson: 'Venditore',
    school_administrator: 'Amministratore scolastico',
    software_engineer: 'Ingegnere del software',
    student: 'Alunno',
    teacher_or_professor: 'Insegnante o Professore',
    web_engineer: 'Ingegnere Web',
    writer_or_editor: 'Scrittore o redattore',
    member: 'Membro | Membri',
    description: {
      admin: 'Amministratore',
      owner: 'Proprietario',
      member: 'Membro | Membri'
    }
  },
  industries: {
    marketing_communication: 'Comunicazione di marketing',
    software_development: 'Sviluppo software',
    media_entertainment: 'Media e intrattenimento',
    business_consulting: 'Consulenza aziendale',
    real_estate: 'Immobiliare',
    education: 'Formazione scolastica',
    trasportation: 'Trasporti',
    law: 'Legge',
    health: 'Salute'
  },
  integrations: {
    asana: 'Asana',
    basecamp_2: 'Campo base 2',
    basecamp_3: 'Campo base 3',
    google_calendar: 'Calendario di Google',
    teams: 'Teams',
    outlook: 'Outlook',
    outlook_calendar: 'Outlook calendar',
    outlook_office_365: 'Calendario di Outlook/Office 365',
    planner: 'Planner',
    project: 'Project',
    power_bi: 'Power Bi',
    azure_devOps: 'Azure DevOps',
    to_do: 'Da Fare',
    gitHub: 'GitHub',
    workspace: 'Spazio di Lavoro',
    calendar: 'Calendario',
    jira: 'Jira',
    microsoft: 'Microsoft',
    ms_to_do: 'MS Da Fare',
    microsoft_to_do: 'Microsoft Da Fare',
    microsoft_teams_calls: 'Microsoft Teams',
    ms_planner: 'Planner',
    link: 'Collegamento',
    microsoft_planner: 'Microsoft planner',
    google_workspace: 'Google Workspace',
    suggest_an_integration: 'Suggerisci un\'integrazione',
    your_daily_activity: 'La tua attività quotidiana'
  },
  phases: {
    social_media: 'Social media',
    blog: 'Blog',
    analytics: 'Analitica',
    bugfix: 'Risoluzione del problema',
    feature: 'Funzionalità',
    design: 'Progetto',
    testing: 'Test',
    meeting: 'Riunione',
    calls: 'Chiamate',
    accounting: 'Contabilità',
    development: 'Sviluppo',
    support: 'Supporto'
  },
  files: {
    xlsx: 'XLSX',
    csv: 'CSV',
    pdf: 'PDF'
  },
  validation: {
    validData: 'Deve contenere una data valida',
    amount_grater_than: 'L\'importo deve essere maggiore o uguale a 0',
    amount_less_than: 'L\'importo deve essere inferiore all\'importo non fatturato',
    name_required: 'Il nome è obbligatorio',
    give_report_a_name: 'Assegnare un nome al report per salvarlo',
    task_name_required: 'Il nome dell\'attività è obbligatorio',
    min_length: 'Deve contenere almeno {length} caratteri'
  },
  tag_lists: {
    marketing: 'Marketing',
    seo: 'SEO',
    adv: 'AVV',
    social: 'Sociale',
    finance: 'Finanza',
    budgeting: 'Budgeting',
    investing: 'Investire',
    design: 'Progetto',
    wireframes: 'Wireframe',
    ideas: 'Idee',
    it: 'IT',
    bugfix: 'Bugfix',
    dev: 'Sviluppo',
    training: 'Formazione',
    internal_communication: 'Comunicazione interna',
    meeting: 'Incontro',
    calls: 'Chiamate',
    support: 'Supporto',
    complaints: 'Reclami',
    review: 'Revisione',
    issues: 'Problemi',
    customer_service: 'Assistenza clienti',
    ticketing: 'Ticketing',
    chat: 'Chat',
    technical_support: 'Supporto tecnico',
    hr: 'risorse umane',
    talent_acquisition: 'Acquisizione di talenti',
    onboarding: 'Inserimento',
    payroll: 'Libro paga'
  },
  components: {
    licenseNumberDialog: {
      title: 'Gestisci licenze',
      licenses: 'Quante licenze desideri nel tuo spazio di lavoro?',
      decrease_licenses: 'Nel caso in cui tu abbia bisogno di meno licenze di quelle incluse nel tuo piano attuale, per favore {contact}.',
      contact: 'contattaci',
      amount_due: 'Oggi ti verrà addebitato {amount} {currency} per {licenses} licenze fino alla fine del tuo periodo di abbonamento.',
      next_renewal: 'Al tuo prossimo rinnovo, il tuo pagamento {period} sarà {amount} {currency}, per {licenses} licenze.'
    },
    addUserDialog: {
      add_a_new_user: 'Aggiungi un nuovo utente',
      email_address: 'Indirizzo e-mail',
      adding_secondary_user: 'L\'aggiunta di un utente secondario ti darà la possibilità di passare rapidamente da un utente all\'altro dal menu del profilo.',
      user_inactiv: 'Questo utente è stato disconnesso per inattività.{br} Reinserisci la tua password.',
      already_logged_in: 'L\'utente ha già effettuato l\'accesso.',
      incorect_login: 'Dati di accesso errati.'
    },
    appDialog: {
      app: 'Applicazione',
      app_logo: 'Logo dell\'app',
      app_created: 'Applicazione creata.',
      app_saved: 'Applicazione salvata.',
      app_name_between: 'Il nome dell\'app è obbligatorio e deve contenere da 3 a 256 caratteri.',
      app_website_url: 'URL del sito web dell\'app',
      client_secret: 'Client secret',
      cancel_uri: 'Cancella URI *',
      developer_name: 'Nome dello sviluppatore *',
      developer_name_between: 'Il nome dello sviluppatore è obbligatorio e deve contenere da 3 a 256 caratteri.',
      description_not_more_than: 'La descrizione non può contenere più di 512 caratteri.',
      max_upload_size: 'Dimensione massima caricamento 2M (jpg, jpeg, png, bmp, svg, webp)',
      privacy_policy: 'URL dell\'informativa sulla privacy',
      redirect_uri: 'URI di reindirizzamento *',
      redirect_uri_required: 'L\'URI di reindirizzamento è obbligatorio.',
      terms_conditions_url: 'URL di termini e condizioni',
      will_be_able_to_uploade: 'Potrai caricare il tuo avatar dopo aver creato l\'app'
    },
    addPhasesDialog: {
      add_phases_to_projects: 'Aggiungi fasi ai progetti'
    },
    bulkEditExpensesDialog: {
      lock_selected_expenses: 'Blocca le spese selezionate',
      unlock_selected_expenses: 'Sblocca le spese selezionate',
      edit_multiple_expenses: 'Modifica più spese'
    },
    bulkEditProjectsDialog: {
      set_a_client: 'Imposta un cliente',
      edit_multiple_projects: 'Modifica più progetti'
    },
    bulkEditUsersDialog: {
      edit_multiple_users: 'Modifica più utenti',
      set_manager: 'Assegna manager'
    },
    clients: {
      search_clients: 'Cerca tra i clienti',
      active_clients: 'Clienti attivi',
      archived_clients: 'Clienti archiviati',
      advise_archive: 'Stai per archiviare un cliente | Stai per archiviare {number} clienti',
      advise_project: 'Ogni progetto allegato a questo cliente verrà archiviato | Ogni progetto allegato a tali clienti verrà archiviato',
      new_client: 'Nuovo cliente',
      number_client_archived: '{number} cliente archiviato | {number} clienti archiviati.',
      number_client_deleted: '{number} cliente eliminato | {number} clienti eliminati.'
    },
    configurationMenu: {
      option_configurations: 'Configurazione delle opzioni',
      actions_onfigurations: 'Configurazione delle azioni',
      time: 'TEMPO',
      money: 'SOLDI'
    },
    calendarConfigurationDialog: {
      calendars_could_not_be_fetched: 'Impossibile recuperare i calendari. Riprova dopo aver autorizzato nuovamente il tuo account.',
      connected: 'Collegato',
      you_have_linked_integration: 'Hai collegato il tuo {name} al tuo {br}account Timeneye',
      it_might_take_minuts: 'Potrebbero essere necessari alcuni minuti prima che i tuoi eventi {br} vengano visualizzati nella dashboard',
      link_to_your_user: 'Collega {name} al tuo utente',
      back_to_dashboard: 'Torna al cruscotto',
      fetching_calendars: 'Recupero calendari...'
    },
    createPhaseDialog: {
      error_creating_phase: 'Errore durante la creazione della fase.',
      create_new_phase: 'Creare una nuova fase',
      account: 'Account | Account',
      created_last_phase: 'Fase creata'
    },
    copyPhaseCategoryDialog: {
      from_existing_project: 'Da progetto esistente',
      from_timeneye_preset: 'Dal preset Timeneye',
      marketing_preset: 'Preset marketing',
      developer_preset: 'Preset sviluppatore',
      sales_preset: 'Preset vendite',
      customer_service_preset: 'Preset servizio clienti',
      select_present_for_phases: 'Seleziona un preset da cui copiare le fasi'
    },
    copyPhasesDialog: {
      filter_projects: 'Filtra progetti',
      copy_phases: 'Copiare le fasi',
      management: 'Gestione'
    },
    clientDialog: {
      you_are_about_to_archive_name: 'Stai per archiviare {name}<br> Tutti i progetti collegati a questo cliente verranno archiviati',
      archiving_client: 'Archiviazione cliente',
      un_archiving_client: 'Ripristino cliente',
      client_archived: 'Cliente archiviato',
      client_unarchived: 'Cliente ripristinato',
      client_name_required: 'È richiesto un nome cliente',
      create_client: 'Crea cliente',
      edit_client: 'Modifica cliente',
      created_last_client: 'Cliente creato',
      deleted_client: 'Cliente eliminato',
      delete_clients: 'Elimina clienti',
      updated_last_client: 'Cliente aggiornato'
    },
    clientArchiveDialog: {
      you_are_about_to_archive: 'Stai per archiviare'
    },
    clientsDeleteDialog: {
      entries_unlinked: {
        all_entries_going_to: 'TUTTE le registrazioni salvate su questi clienti {0}',
        unlinked_from_it: 'saranno scollegate da esso'
      },
      dont_want_to_lose_client: 'Se non vuoi perdere i tuoi dati, ti consigliamo di archiviare questo cliente. | Se non vuoi perdere i tuoi dati, ti consigliamo invece di archiviare questi clienti.'
    },
    dashboard: {
      dashboard: 'Bacheca',
      another_member_calendar: 'Stai visualizzando il calendario di un altro membro',
      timezone_alert: 'ATTENZIONE: Il tuo attuale fuso orario è diverso da quello nelle tue impostazioni, {go_to_profile_settings}',
      go_to_profile_settings: 'si prega di aggiornarlo per evitare problemi.',
      go_to_profile_settings_tooltip: 'Vai alle impostazioni del profilo',
      ignore_timezone_alert: 'Chiudi',
      collapse: 'Comprimi',
      loading_calendar: 'Caricamento eventi del calendario...',
      loading_calendar_wait: 'Caricamento degli eventi del calendario. L\'operazione potrebbe richiedere del tempo',
      linked_to_account: 'è collegato a questo account. Clicca qui per saperne di più!',
      personal_budgets: 'Budget personali',
      havent_budgets: 'Non hai budget personali.',
      havent_project_budgets: 'Non hai alcun budget assegnato ai tuoi progetti',
      how_crate_budget: 'Come creare un budget',
      old_timers: 'Hai un timer in attesa di essere salvato come registrazione | Hai {timers_count} timer in attesa di essere salvati come registrazione',
      insights: 'Approfondimenti',
      client_recap: 'Riepilogo del cliente',
      link_ms_todo: 'Collega MS Todo',
      manage_ms_todo: 'Gestisci MS To Do',
      clients_recap: 'Riepilogo dei clienti',
      projects_recap: 'Riepilogo dei progetti',
      phase_recap: 'Riepilogo cat. fase',
      no_element_selected_time: 'Non sono presenti registrazioni su nessun {element} nell\'intervallo di tempo selezionato.',
      time_recap: 'Riepilogo del tempo',
      open_recap: 'Apri il riepilogo per vedere l\'ultima registrazione dei membri.',
      no_time_tracked: 'Nessuno dei membri del tuo team ha tracciato alcun tempo.',
      recap: 'Riepilogo',
      sort_tasks: 'Ordina le attività',
      add_new_task: 'Aggiungi nuova attività',
      no_matching_filters: 'Nessuna attività corrispondente ai filtri',
      link_ms_to_do: 'Collega MS To Do',
      dont_show_this_anymore: 'Non mostrarlo più',
      import_from_ms: 'Importa da MS Planner',
      try_to_sync_again: 'Prova a eseguire nuovamente la sincronizzazione',
      dont_show_this: 'Non mostrarlo',
      locked_date: 'Data bloccata',
      not_your_calendar: 'Non il tuo calendario',
      cant_track_time_for_other_members: 'Non puoi registrare tempo degli altri membri utilizzando il calendario, utilizza invece il pulsante di registrazione.',
      search_task: 'Cerca attività',
      cannot_edit_other_member_entries: 'Non puoi modificare le registrazioni mentre guardi il calendario di un altro membro.',
      average_mood: 'Umore medio',
      move: 'Rilascia qui per \\A SPOSTARE \\A in questo giorno',
      copy: 'Rilascia qui per \\A COPIA \\A in questo giorno',
      tag_list_recap: 'Riepilogo gruppi etichette',
      hold_shift: '(tieni premuto MAIUSC per copiare)',
      link_calendar: 'Collega il calendario',
      open_service_link: 'Apri il collegamento al servizio in una nuova scheda',
      total_time_of_total_working_time: '{total_time} di {total_working_time}',
      no_suggestion: 'Nessun suggerimento',
      refresh: 'Ricarica',
      update_bassed_on_teams_call_log: 'Aggiornamento basato sul registro delle chiamate dei team. (Durata originale: {0})',
      actual_duration: 'Durata effettiva',
      timeline: 'Timeline',
      cards: 'Schede'
    },
    dialogs: {
      action_not_reversible: 'ATTENZIONE: questa azione non è reversibile.',
      element_delete: {
        any_element_will_be_deleted: 'Tutti i dati collegati a questi {element} verranno immediatamente cancellati e sarà {not} possibile ripristinarli.',
        not: 'non'
      },
      disabling_option: 'Disabilitando questa opzione non verranno sincronizzati i futuri appuntamenti privati, ma non verranno eliminati quelli già importati.',
      feedback: 'Suggerimenti',
      hide: 'Nascondere',
      last_timer: 'Ultimo timer',
      manage_phases: 'Gestisci fasi',
      no_matching_filters: 'Nessun risultato corrispondente per i filtri attuali',
      phase_name: 'Nome della fase',
      project_with_no_tags_edit: 'Questo progetto non ha etichette. Modifica le impostazioni del progetto per aggiungere etichette.',
      users_invited: 'Utenti invitati',
      ok: 'OK',
      select_projects: 'Seleziona progetti',
      selected_users: 'Utenti selezionati',
      set_expense_category: 'Imposta una categoria di spesa',
      workspace_access_level: 'Livello di accesso all\'account'
    },
    dashboardSettingsDialog: {
      clients_recap: 'Riepilogo dei clienti',
      entity_notes: 'Note sull\'entità',
      dont_show_any_module: 'Non mostrare alcun modulo',
      dashboard_settings_saved: 'Impostazioni della dashboard salvate',
      modules_state: {
        modules: 'Moduli:',
        modules_none: '{0} Nascosto',
        modules_top_bar: '{0} Barra superiore',
        modules_bottom_bar: '{0} Barra inferiore',
        modules_left_sidebar: '{0} Barra laterale sinistra',
        modules_right_sidebar: '{0} Barra laterale destra'
      },
      projects_recap: 'Riepilogo dei progetti',
      phase_categories_recap: 'Riepilogo delle categorie di fase',
      dashboard_configuration: 'Configurazione del cruscotto',
      bottom: 'In fondo',
      left: 'Sinistra',
      right: 'Giusto',
      top: 'Superiore'
    },
    existingDomainDialog: {
      workspace_domain_exist: {
        looks_like_workspace_domain: 'Sembra che un account con il dominio {element} esista già'
      },
      probably_someone_has_workspace: 'Probabilmente qualcuno del tuo team ha {br} già creato un account su timeneye.',
      please_wait_invitation: 'Attendi un\'e-mail di invito o contatta {br} l\'amministratore del tuo account.',
      ok_got_it: 'Ok, capito',
      create_workspace: {
        i_want_to: 'Voglio continuare e creare un {0}',
        create_workspace: 'nuovo spazio di lavoro'
      },
      new_workspace: 'nuovo spazio di lavoro',
      sure_create_workspace: 'Sei sicuro di voler creare un nuovo account?',
      keep_in_mind: 'Per favore, tienilo presente',
      wont_be_able_join_workspace: 'Non potrai partecipare ad altre aree di lavoro',
      you_can_be_in_single_workspace: 'Puoi far parte di un unico account',
      join_workspace_invited: 'Se vuoi unirti a uno <strong>account esistente</strong>, devi essere <strong>invitato</strong>'
    },
    expenseCategoryDialog: {
      this_category_unit_price: 'Questa categoria ha un prezzo unitario',
      expense_category_created: 'Categoria di spesa creata',
      expense_category_name: 'Nome della categoria di spesa',
      edit_expense_name: 'Modifica {expense_name}',
      unit_name: 'Unità di misura',
      unit_name_placeholder: 'e.g km, fotocopie'
    },
    expenseDialog: {
      you_are_deleting_expense: 'Stai per eliminare questa spesa<br/>Questa azione richiede conferma',
      expense_created_successfuly: 'Spesa creata con successo',
      quantity: 'Quantità',
      create_new_expense: 'Crea nuova spesa',
      expense_details: 'Dettagli spesa',
      deleted_expense: 'Spesa eliminata',
      edit_expense: 'Modifica spesa',
      member: 'Membro | Membri',
      updated_last_expenses: 'Spese aggiornate'
    },
    entries: {
      revenue: 'Ricavo',
      x_more_tags: '+{el} altre etichette',
      hide_filters: 'Nascondi filtri',
      show_filters: 'Mostra filtri',
      number_entries_selected: '{number} selezionato.',
      your_activity: 'La tua attività',
      advanced_filters: 'Filtri avanzati',
      notes_integration_info: 'Note e informazioni sull\'integrazione',
      x_items_selected: '{el} elementi selezionati',
      x_time_total: '{el} totale',
      total: 'totale',
      billed_status: 'Stato di fatturazione',
      format: 'Formato',
      delete_selected_items: 'Eliminare elementi selezionati',
      update_entries: 'Aggiorna registrazioni',
      no_data_for_timeframe_filters: 'Nessun dato per l\'intervallo di tempo e i filtri selezionati.',
      run_entries_report: 'Esegui report sulle registrazioni',
      export_selected_entries: 'Esporta le registrazioni selezionate',
      export_entries_filters: 'Esporta le registrazioni in base ai filtri applicati',
      listed_out_of_total: '{el_number} elencate su {total_el} totali',
      error_exporting_file: 'Errore durante l\'esportazione di {el}.',
      error_generating_pdf: 'Si è verificato un errore durante la generazione del PDF',
      delete_selected_entries: 'Elimina le registrazioni selezionate',
      user_confirmation_dialog: "\n        Stai per aggiornare <strong>{sanitized_length}</strong> {elemento}<br />\n        Modifiche:<br />\n        <ul>\n        <li>{changes_length}</li>\n        </ul>\n      ",
      open_in_a_new_tab: 'Apri in una nuova scheda',
      ignore_suggestion: 'Ignora il suggerimento',
      unknown_project: 'Progetto sconosciuto',
      to_file: 'a {file}',
      date_from_to_date_to: 'da {date_from} a {date_to}',
      any_state: 'Qualsiasi stato',
      no_changes: 'Nessun cambiamento',
      paused: 'In pausa.',
      set_as_billable: 'Imposta come fatturabile',
      set_as_billed: 'Imposta come fatturato',
      set_as_unbilled: 'Imposta come non fatturato',
      set_as_not_billable: 'Impostato come non fatturabile',
      set_owner: 'Imposta proprietario',
      set_project: 'Imposta progetto',
      set_phase: 'Imposta fase',
      set_date: 'Impostare la data',
      set_billed_status: 'Imposta lo stato di fatturazione',
      search: 'Ricerca...',
      started: 'Iniziato.',
      without_group: 'Senza gruppo',
      from_date_to_date: 'dal {date_from} al {to_date}',
      entries_out_of_total: '{current_value} elencate su {totalEntries}',
      without_client: 'Senza cliente',
      without_category: 'Senza categoria',
      without_tag: 'Senza etichetta',
      without_tag_list: 'Senza gruppo di etichette'
    },
    expenseCategories: {
      expense_category_deletion: 'Cancellazione categoria di spesa',
      category_deleted: 'Categoria eliminata',
      category_state_archived: 'Categoria archiviata',
      category_state_unarchived: 'Categoria non archiviata',
      category_cant_be_deleted: 'Questa categoria non può essere eliminata perché sono presenti spese ad essa collegate',
      curency_unit_price_per_unit_name: '{curency_symbol} {unit_price_first} ogni {unit_name_second}',
      active_categories: 'Categorie attive',
      deactivated_categories: 'Categorie archiviate',
      new_expense_category: 'Nuova categoria di spesa',
      you_are_deleting_expense_category: 'Stai per eliminare questa categoria di spesa<br/><div class="text-body2 q-mt-sm">Questa azione non è reversibile. Se non vuoi perdere i tuoi dati, ti consigliamo di archiviare questa categoria.</div>'
    },
    expenses: {
      search_within_expenses: 'Cerca tra le spese',
      set_billing_status_for_all_selected_expenses: 'Imposta lo stato di fatturazione per tutte le spese selezionate',
      set_expense_category_for_all: 'Imposta la categoria di spesa per tutte le spese selezionate',
      category_cannot_be_changed: 'Non è possibile modificare la categoria per le spese con un prezzo unitario fisso.',
      lock_expenses: 'Blocca le spese',
      unlock_expenses: 'Sblocca le spese',
      locked: 'Questa spesa non può essere modificata',
      locked_by_approval: 'Questa spesa è già stata approvata e non può essere modificata',
      dont_have_permision: 'Le spese approvate non possono essere modificate',
      you_are_about_to_delete_expense: 'Stai per eliminare {el}.<br/> Questa azione richiede conferma',
      this_expense: 'questa spesa',
      update_expenses_lock: 'Aggiorna il blocco delle spese',
      you_are_about_change_the_billing_status_of_one_expense: 'Stai per modificare lo stato di fatturazione delle <b>spese</b>.<br/> Questa azione richiede conferma | Stai per modificare lo stato di fatturazione di <b>{number} spesa</b>.<br/> Questa azione richiede conferma',
      you_are_about_lock_one_expense: 'Stai per bloccare <b>spesa</b>.<br/> Questa azione richiede conferma | Stai per bloccare <b>{number} spese</b>.<br/> Questa azione richiede conferma',
      you_are_about_unlock_one_expense: 'Stai per sbloccare le <b>spese</b>.<br/> Questa azione richiede conferma | Stai per sbloccare <b>{number} spese</b>.<br/> Questa azione richiede conferma',
      you_are_about_edit_one_project: 'Stai per modificare il <b>progetto</b>.<br/> Questa azione richiede conferma | Stai per modificare <b>{number} progetti</b>.<br/> Questa azione richiede conferma',
      expense_deleted: '{number} spesa eliminata | {number} spese eliminate',
      expense_updated: '{number} spesa aggiornata | {number} spese aggiornate',
      any_projects: 'Qualsiasi progetto',
      any_members: 'Qualsiasi membro',
      any_expense_category: 'Qualsiasi categoria di spesa',
      new_expense: 'Nuova spesa',
      set_expense_category: 'Imposta la categoria di spesa',
      any_client: 'Qualsiasi cliente',
      any_group: 'Qualsiasi gruppo'
    },
    attachments: {
      attachment: 'Allegato | Allegati',
      attach_file: 'Allega file',
      max_size: 'La dimensione massima è di 50MB per le immagini e di 3MB per tutti gli altri tipi di file.',
      download: 'Scarica',
      remove: 'Elimina'
    },
    groups: {
      invalid_value: 'Valore non valido',
      users_without_group: 'Utenti senza gruppo',
      invite_users: 'Invita utenti',
      invite_team_member: 'Invita membri del team',
      add_new_group: 'Aggiungi nuovo gruppo',
      edit_team_member: 'Modifica membro del team',
      edit_group: 'Modifica gruppo'
    },
    groupDialog: {
      group_name: 'Nome del gruppo',
      group_deleted: 'Il gruppo è stato eliminato',
      group_created: '{name} è stato creato',
      info: 'Informazioni',
      new_group: 'Nuovo gruppo',
      member: 'Membro | Membri'
    },
    groupAddUserDialog: {
      all_team_member_is_part_of_group: 'Tutti i membri del tuo team fanno già parte di un gruppo. Ogni membro del team può far parte solo di un singolo gruppo.',
      add_member_to: 'Aggiungi membro a {name}'
    },
    groupDeleteDialog: {
      any_user_will_be_removed: 'Ogni utente in questo gruppo verrà automaticamente rimosso dai progetti collegati.',
      group_deletion: 'Eliminazione del gruppo',
      delete_group: 'Stai per eliminare il gruppo "{name}."'
    },
    helpdesk: {
      watch_the_onboarding: 'Guarda l\'onboarding',
      product_guide_faq: 'Guida al prodotto e domande frequenti',
      contact_our_support_team: 'Contatta il nostro team di supporto',
      service_status: 'Stato del servizio',
      roadmap: 'Piano di sviluppo',
      webapp_dev: 'webapp v.3.01.21 - {br}- Sviluppato da',
      dm_digital: 'DM Digital Software S.R.L',
      customize_layout: 'Personalizza il layout della tua dashboard in base alle tue preferenze',
      you_can_set_timers_automatically: 'Puoi impostare i timer in modo che si fermino automaticamente a una determinata ora e ti inviino un avviso',
      track_manage_time: 'Tieni traccia e gestisci il tuo tempo all\'interno delle tue webapp preferite con il nostro widget Chrome',
      can_export_entries: 'Sapevi che puoi esportare le tue registrazioni in CSV e PDF?',
      timeneye: 'Timeneye'
    },
    integration: {
      sync_status: 'Sinc',
      integration: 'Integrazione',
      browser_widget: 'Widget del browser',
      our_browser: {
        supports: 'Il nostro widget del browser supporta {0}.',
        web_app: '{el} applicazione web'
      },
      allows_track_time: 'Ti permette di registrare il tuo tempo direttamente su {el} senza lasciare la loro app web aggiungendo dati significativi alle voci e ai timer.',
      chrome: 'Chrome',
      firefox: 'Firefox',
      edge: 'Edge',
      synchronization_settings: 'Impostazioni di sincronizzazione',
      each_row_manages_a_syncronization: 'Ogni riga nella tabella gestisce una funzionalità di sincronizzazione.',
      you_can_enable_a_feature: 'È possibile abilitare una funzione facendo clic sul pulsante di attivazione/disattivazione e abilitare le notifiche relative a una funzione facendo clic sull\'icona della campana.',
      refresh_authorization: 'Aggiorna l\'autorizzazione',
      unlink_name: 'Scollega {name}',
      link_name: 'Collega {name} al tuo utente',
      configuration: 'Configurazione',
      integration_configurable_by_admin: 'Questa integrazione può essere configurata solo da un utente amministratore.',
      data_security: 'Sicurezza Dei Dati',
      requested_scopes: 'Ambiti richiesti',
      purpose: 'Scopo',
      privacy_and_security: 'Privacy e sicurezza',
      timeneye_offers_seamless_integration_with_microsoft: "\n        Timeneye offre una perfetta integrazione con i servizi Microsoft per migliorare la produttivit\xE0 e semplificare la gestione delle attivit\xE0.\n        Quando si integra Timeneye con Microsoft, vengono richieste determinate autorizzazioni e l'accesso ai dati per garantire una funzionalit\xE0 fluida.\n        Di seguito, delineiamo i permessi e i dati richiesti per MS Team CALLS.",
      call_records_ead_all: 'CallRecords.Read.All: questo ambito consente a Timeneye l\'accesso privilegiato ai callRecords per ogni chiamata e riunione online all\'interno dell\'organizzazione, comprese le chiamate da e verso numeri di telefono esterni.',
      with_these_permissions: 'Con queste autorizzazioni, Timeneye regola la durata dei suggerimenti esistenti importati da Outlook, per abbinarli alle chiamate effettuate su di essi e importa qualsiasi chiamata non programmata come nuovi suggerimenti.',
      what_data_does_timeneye_access_and_why: 'A quali dati accede Timeneye e perché? Leggi l\'articolo completo.',
      timeneye_respects_user_privacy: '{0} Timeneye rispetta la privacy degli utenti ed è conforme alle normative sulla protezione dei dati. Tutti i dati a cui si accede dai servizi Microsoft vengono gestiti in modo sicuro e utilizzati esclusivamente a fini di integrazione.',
      timeneye_employs_secure_authentication_mechanisms: '{0} Timeneye utilizza meccanismi di autenticazione sicuri per garantire che solo gli utenti autorizzati possano accedere alle integrazioni Microsoft.',
      any_data_transmitted_between: '{0} Tutti i dati trasmessi tra Timeneye e i servizi Microsoft vengono crittografati per impedire l\'accesso non autorizzato.',
      data_protection: 'Protezione dati',
      authentication: 'Autenticazione',
      data_encryption: 'Crittografia dei dati',
      by_granting_permissions_users_can_enjoy_benefits: "\n        Con la concessione di questi permessi, gli utenti possono godere appieno dei vantaggi dell'integrazione di Timeney con i servizi Microsoft,\n        migliorare l'efficienza della produttivit\xE0 e della gestione delle attivit\xE0 garantendo al contempo la sicurezza dei dati e la privacy.\n        Se hai dubbi o hai bisogno di ulteriore assistenza, non esitare a {0}",
      contact_support_team: 'contattare il nostro team di supporto.'
    },
    integrations: {
      learn_more: 'Scopri di più',
      timeneye_browser_extension: 'Estensione del browser Timeneye',
      install: 'Installa',
      please_install_our_browser_extension: 'Per visualizzare i controlli di monitoraggio del tempo all\'interno del tuo strumento preferito, installa la nostra estensione del browser.{br}Ecco come appariamo nell\'interfaccia. Assicurati di installarlo su qualsiasi computer che utilizzi.',
      connect: 'Connetti',
      guides: 'Guide',
      search_within_integrations: 'Cerca all\'interno delle nostre integrazioni'
    },
    inviteUsersDialog: {
      you_have_x_licenses: 'Ti restano {element} licenze.',
      owners_can_add_licenses: 'Solo i proprietari possono aggiungere più licenze',
      remove_all_selected_users: 'Rimuovi tutti gli utenti selezionati',
      add_to_recommended: 'Aggiungi a (consigliato)',
      select_group: 'Seleziona gruppo',
      remove_user: 'Rimuovi utente',
      temmates_invited: 'I tuoi colleghi sono stati invitati!',
      can_see_when_temmates_join_your_workspace: {
        can_see_when_temmates_join: 'Puoi vedere quando i tuoi colleghi si uniranno {br} al tuo spazio di lavoro nella sezione {team_section} o in {element}',
        team_section: 'Sezione Team'
      },
      add_from_microsoft: 'Aggiungi da Microsoft',
      add_from_google_workspace: 'Aggiungi da Google Workspace',
      invite_new_team_members: 'Invita nuovi membri del team',
      add_more: 'Aggiungere altro',
      invite: 'Invitare'
    },
    inviteUsersErrorsDialog: {
      proceed_to_dashboard: 'Procedi alla dashboard',
      impossible_invite_some_users: 'Impossibile invitare alcuni utenti',
      fake_mail: 'nome@organizzazione.com'
    },
    inviteUsersFromIntegrationDialog: {
      garant_permission: 'Concedi l\'autorizzazione a {name}',
      available_users: 'Utenti disponibili',
      select_all_visible_users: 'Seleziona tutti gli utenti visibili',
      error_retrieving_the_users_list: 'Qualcosa è andato storto durante il recupero dell\'elenco degli utenti dal tuo account. Assicurati che l\'account scelto sia un account aziendale.',
      authorization_refreshed: 'Autorizzazione aggiornata',
      retrieving_users: 'Recupero utenti...',
      automatically_import_team_mebers: {
        automatically_import: '{team_members} automaticamente in Timeneye.{br}Tutto quello che devi fare è concederci l\'autorizzazione per accedere all\'elenco dei membri del tuo team {element}.',
        team_members: 'importa i membri del tuo team'
      },
      search_by_name: 'Cerca per nome {name}',
      search_by_name_or_email: 'Cerca per nome o email',
      invite_users_from: 'Invita utenti da {name}',
      invite_team_by: {
        not_ready: 'Non sei pronto a concedere i permessi? {invite_by_email}',
        invite_by_email: 'Invita i membri del tuo team via email'
      },
      something_went_wrong_retrieving_users: 'Qualcosa è andato storto durante il recupero dell\'elenco degli utenti dal tuo account. Assicurati che l\'account scelto sia un account aziendale.'
    },
    keyboardShortcutsDialog: {
      open_register_time: 'Aprire la finestra di dialogo "Registra ora".',
      open_entries: 'Apri elenco "Registrazioni"',
      open_timers: 'Apri la finestra di dialogo "Timer".'
    },
    management: {
      logout: 'Disconnettiti'
    },
    notifications: {
      no_notifications_available: 'Nessuna notifica disponibile'
    },
    password: {
      at_least_8_character: 'Almeno 8 caratteri di lunghezza',
      at_least_a_digit: 'Almeno una cifra',
      at_least_a_capital_letter: 'Almeno una lettera maiuscola',
      at_least_a_special_character: 'Almeno un personaggio speciale'
    },
    phases: {
      use_phases_to: {
        track_time: 'Utilizza le fasi per tenere traccia del tuo tempo in modo più organizzato. {0}',
        learn_more: 'Scopri di più'
      },
      project_phases_activities: '(Fasi/attività del progetto - ovvero Bandi, Riunioni, Contabilità)',
      the_phase_activity_category: '(La categoria di fase/attività, ovvero Vendite, Marketing, Sviluppo)',
      time_tracked: 'Tempo <br />registrato'
    },
    pickers: {
      all_element: 'Tutti i {el}',
      any_element: 'Qualsiasi {el}',
      date_format: 'Formato data',
      after_creating_new_entry_timer: 'Dopo aver creato una nuova registrazione/timer',
      close_form: 'Chiudi modulo',
      leave_form_open: 'Lasciare il modulo aperto',
      primary_action: 'Azione primaria',
      interface_duration_format: 'Formato della durata dell\'interfaccia',
      reports_tables_duration_format: 'Formato durata report e tabelle',
      first_day_of_week: 'Primo giorno della settimana',
      field_saved_automatically: 'Questo campo viene salvato automaticamente in caso di modifica',
      deselect_all: 'Deseleziona tutto',
      no_element_found: 'Nessun {el} trovato.',
      invite_member: 'Invita nuovo membro',
      search_within: 'Cerca all\'interno di {el}',
      search_within_tags: 'Cerca all\'interno delle etichette',
      new_row_named: '{el} chiamato {input}',
      manage_tags: 'Gestisci etichette',
      requires_at_least_one_tag: 'Il progetto selezionato richiede almeno una etichetta per registrazione',
      missing_tag_for_tag_list: 'Etichetta mancante per il gruppo di etichette richiesto',
      add_tags_to_tag_list: 'Questo gruppo di etichette non ha etichette. Aggiungine una nuova',
      select_one_or_more_type: 'Seleziona uno o più {el}',
      type_name: 'Nome {el}',
      no_el: 'nessun {el}',
      date_from: 'Dalla data',
      date_to: 'Alla data',
      create_new_element: 'Crea nuovo {el}',
      create_new_option: 'Crea nuova opzione',
      create_new_task_list: 'Crea un nuovo elenco di attività',
      create_new_tag_list: 'Crea un nuovo gruppo di etichette',
      no_selection: 'Nessuna selezione',
      no_project_selected: 'Nessun progetto selezionato',
      picker: 'Selettore',
      option: 'Opzione | Opzioni',
      appLanguage: {
        beta: 'Alcune lingue sono ancora in versione beta. Se riscontri problemi, faccelo sapere.'
      },
      description_non_billable: 'Ore di lavoro per le quali il cliente non sarà fatturato (ad es. riunione di team)',
      description_billable: 'Registrazioni che potrebbero essere non fatturate o fatturate',
      description_unbilled: 'Ore di lavoro per le quali verrà addebitato il cliente.',
      description_billed: 'Ore lavorate che la tua azienda ha già fatturato ai clienti.'
    },
    profile: {
      user_info: 'Informazioni sull\'utente',
      app_settings: 'Impostazioni dell\'app',
      suggestion: 'Suggerimenti',
      your_preferences_updated: 'Le tue preferenze sono state aggiornate',
      language: 'Lingua',
      language_help_us: 'Si prega di notare che le nostre traduzioni sono ancora in beta. Se noti traduzioni errate o hai suggerimenti per miglioramenti, faccelo sapere! Puoi contribuire direttamente tramite {0}.',
      language_of_workspace: 'Questa è la lingua che verrà utilizzata per il tuo account.',
      number_formatting: 'Formattazione dei numeri',
      select_your_language: 'Seleziona la tua lingua per formattare i numeri in base agli standard del tuo paese.',
      this_wont_affect_language: 'Queste impostazioni non influenzeranno la lingua dell\'applicazione.',
      date_and_country: 'Data e paese',
      country_and_timezone_settings: {
        settings: 'Le impostazioni {0} vengono utilizzate per mostrare le date e gli orari in base alla tua posizione.',
        country_and_timezone: 'paese e fuso orario'
      },
      chose_fisrts_day_of_week_and_format: {
        chose: 'Scegli {0} e {1} in base alle tue preferenze.',
        fisrts_day_of_week: 'primo giorno della settimana, giorni del fine settimana',
        date_format: 'formato data'
      },
      timeformats_are_used_for_entries: {
        are_used_for_entries: 'I {0} vengono utilizzati per le registrazioni e timer nel calendario e nei report.',
        timeformats: 'formati degli orari'
      },
      auto_stop_timers: 'Arresto automatico dei timer',
      select_when_to_autostop: {
        select_when_to: 'Seleziona l\'ora del giorno in cui Timeneye dovrebbe {0} automaticamente i tuoi timer.',
        stop: 'fermare'
      },
      hint_when_to_set_autostop: {
        when_to_set_autostop: '{0}: imposta il salvataggio automatico in base all\'orario di chiusura dell\'ufficio.',
        hint: 'Suggerimento'
      },
      enable_autostop: 'Abilita l\'arresto automatico',
      send_email: 'Invia una email',
      stop_timers_at: 'Arresta i timer alle',
      register_time_form: 'Modulo di registrazione del tempo',
      primary_action_will_switch_entries_timers: ' Le impostazioni dell\'azione principale cambieranno i pulsanti registrazione/timer in "Registrazione".{br}Le scorciatoie da tastiera cambieranno di conseguenza',
      whats_best_for_me: 'Cosa è meglio per me?',
      if_you_have_entries: "Se inserisci registrazioni solo alla fine della giornata, potresti essere pi\xF9\n      a tuo agio impostando \"Registrazione\" come azione principale e lasciando aperto il\n      modulo dopo aver creato le registrazioni. Se tracci il tempo\n      in movimento, potresti preferire avere \"Timer\" come azione principale e\n      chiudere automaticamente il modulo.",
      if_you_have_large_number_of_projects: "Se hai un grande numero di progetti e clienti dovresti\n      abilitare il filtro per cliente.<br />In questo modo potrai filtrare\n      i progetti per cliente.",
      show_client_filter: 'Mostra filtro cliente',
      speeds_time_by_crating_suggestion: {
        speeds_time: 'Timeneye accelera l\'esperienza di registrazione del tempo {0} in base alla tua attività quotidiana e alle integrazioni.',
        creating_suggestions: 'creando suggerimenti'
      },
      all_sugestion_older_than_30: 'Tutti i suggerimenti più vecchi di 30 giorni vengono eliminati automaticamente.',
      new_to_timeneye: 'Se hai appena iniziato a utilizzare Timeneye, potrebbe essere necessario attendere un paio di giorni prima di poter visualizzare i suggerimenti.',
      enable_old_suggestion_style: 'Abilita il vecchio stile di suggerimento',
      system_emails: 'E-mail di sistema',
      system_emails_cannot_be_disabled_message: {
        message: "\n{system_emails_cannot_be_disabled}\n{br}Includono inviti utente, fatture,\n        avvisi di fatturazione/sottoscrizione, esportazioni dati, eliminazione spazi di lavoro,\n        avvisi di sicurezza e comunicazioni dagli amministratori del tuo account.",
        system_emails_cannot_be_disabled: 'Le e-mail di sistema non possono essere disabilitate'
      },
      onboarding_emails: 'E-mail di onboarding',
      emails_to_guide_trial: 'Una serie di email per guidarti durante il periodo di prova.',
      daily_reminder: 'Promemoria quotidiano',
      will_understand_how_many_hours: "Dopo che l'hai usato per un po', Timeneye capir\xE0\n      quanti ore al giorno di solito lavori. Abilitando il promemoria quotidiano\n      ti invieremo un'email quando dimentichi di tracciare il tempo o se\n      tracci meno del solito.",
      weekly_status: 'Stato settimanale',
      recive_email_teamm_tracked: 'Ricevi un\'e-mail con un report sullo stato per vedere cosa ha monitorato il tuo team durante l\'ultima settimana.',
      feature_avaiable_for_pm_admin: 'Questa funzione è disponibile per PM e amministratori.',
      automation_emails: 'E-mail di automazione',
      enable_for_email_from_automations: 'Abilita questa opzione per poter ricevere le e-mail dalle automazioni e poter creare automazioni relative ai report pianificati.',
      news_from_team: 'Novità dal team',
      recive_newsletter: 'Ricevi una newsletter per informare i nostri utenti sulle ultime funzionalità rilasciate e novità su Timeneye.',
      will_send_newsletter_once_a_month: {
        will_send_newsletter: 'Invieremo la newsletter {0}',
        max_once_month: 'massimo una volta al mese.'
      },
      api_updates: 'Aggiornamenti dell\'API',
      if_you_use_our_api: 'Se utilizzi le nostre API ti consigliamo di iscriverti a questa mailing-list.',
      daily_recap: 'Riepilogo giornaliero',
      daily_recap_description: 'Ricevi un riepilogo giornaliero del tuo tempo tracciato.',
      expires_at: 'Scade alle',
      revoke: 'Revocare',
      copy_token: 'Copia il seguente token in un luogo sicuro',
      you_wont_be_able_access: 'Non potrai accedere a queste informazioni in futuro',
      issue_new_personal_tocken: 'Emettere un nuovo token di accesso personale',
      give_this_token_name: 'Dai a questo token un nome mnemonico',
      revoke_access_token: 'Revoca token di accesso',
      are_you_sure_removing_token: 'Sei sicuro di voler procedere con la revoca del token denominato <strong>{el}</strong>?<br/>Tutte le applicazioni che lo utilizzano attualmente perderanno la sessione di autenticazione.',
      token_copied: 'Token copiato negli appunti',
      listed_personal_token: 'Qui sono elencati i token di accesso personali emessi per il tuo utente.',
      bearer_token_issued_by_personal_access: {
        bearer_token_issued: "Il token Bearer rilasciato come token di accesso personale pu\xF2 essere utilizzato per autenticarsi alle API senza creare un'applicazione dal portale sviluppatore.{br}{br}\n        Per autenticare le richieste, riempi l'intestazione HTTP \"Autorizzazione\" con {bearer_token}",
        bearer_token: '"Bearer <token>"'
      },
      personal_access_token_expire: {
        token_expire: 'I token di accesso personale scadono dopo il giorno {one_year} e non possono essere aggiornati.{br}',
        one_year: 'un anno'
      },
      please_visit_api: {
        please_visit: 'Per ulteriori informazioni, visitare il {0}',
        api_documentation: 'Pagina della documentazione dell\'API'
      },
      authorized_apps: 'App autorizzate',
      listed_third_party_apps: 'Qui sono elencate le app di terze parti che hai autorizzato.',
      legacy_apps_are_scheduled: 'È previsto che le app legacy vengano ritirate alla fine del 2024.',
      created_by: 'Creato da',
      no_apps_authorized: 'Nessuna app autorizzata',
      revoke_app: 'Revoca app',
      revoke_access_to_app: 'Sei sicuro di voler revocare il tuo accesso all\'app {el}?',
      access_to_app_revoked: 'L\'accesso all\'app è stato revocato.',
      avatar_visible_to_you_and_members_of_team: 'Questo avatar sarà visibile a te e ai membri del tuo team.',
      drop_image: 'Rilascia la tua immagine ovunque o fai clic qui per selezionarla dal tuo dispositivo',
      max_image_size: 'Dimensione massima caricamento 2M (jpg, jpeg, png, bmp, svg, webp)',
      name_will_be_visible_to: 'Il tuo nome sarà visibile a tutti i membri del team delle aree di lavoro a cui sei collegato in base alle configurazioni delle aree di lavoro.',
      email_will_be_visible_to: 'La tua email sarà visibile a qualsiasi amministratore dell\'account a cui sei collegato.',
      enter_new_email: 'Inserisci il tuo nuovo indirizzo email.{br}Riceverai un\'email con un codice di conferma.',
      confirmation_code: 'Codice di conferma',
      enter_the_code: 'Inserisci il codice che hai ricevuto nella nuova email.{br}Il codice scadrà dopo 10 minuti',
      change_password: 'Cambiare la password',
      keep_information_safe: 'Per mantenere le tue informazioni al sicuro, la tua password deve essere lunga almeno 8 caratteri e contenere una cifra e un carattere speciale',
      you_will_be_logged_out: 'Nota: se cambi la password verrai disconnesso da qualsiasi sessione mobile.',
      add_another_account: 'Aggiungi un altro account Timeneye in modo da poter passare dall\'uno all\'altro dall\'angolo in alto a destra.',
      too_many_attempts: 'Troppi tentativi',
      token_name: 'Nome del token',
      third_party_apps: 'App di terze parti',
      day_picker_label_on: 'il',
      time_picker_label_at: 'alle',
      actions: 'Azioni',
      edit_email: 'Modifica e-mail',
      updated_last_email: 'E-mail aggiornata',
      updated_last_password: 'password aggiornata'
    },
    project: {
      add_users_to_all_selected: 'Aggiungi utenti a tutti i progetti selezionati',
      you_have_been_flagged_as: 'Sei stato contrassegnato come "{el}" di questo progetto.',
      this_project_is_public: 'Questo progetto è pubblico e automaticamente disponibile per tutti i {br} membri dell\'account.',
      project_flagged_as_api: 'Questo progetto è contrassegnato come Solo API. Qualsiasi registrazione/timer su {br}questo progetto è bloccato.',
      project_linked_with: 'Progetto collegato a {el}',
      all_active_projects: 'Tutti i progetti attivi',
      all_archived_projects: 'Tutti i progetti archiviati',
      my_active_projects: 'I miei progetti attivi',
      my_archived_projects: 'I miei progetti archiviati',
      sync_el_data: 'Sincronizza i dati {el}',
      project_syncing: 'Il progetto è in fase di sincronizzazione',
      edit_team: 'Modifica squadra',
      edit_phases: 'Modifica fasi',
      edit_tags: 'Modifica etichette'
    },
    projectedit: {
      btn_bulk_edit: 'Modifica collettiva',
      group_name: 'Gruppo {name}',
      remove_member_from_project: 'Rimuovi membro dal progetto',
      no_user_linked_to_project: 'Non ci sono utenti collegati a questo progetto',
      members_total_budget: 'Budget totale dei membri:',
      project_budget: 'Budget del progetto:',
      demo_cannot_be_archived: 'I progetti demo non possono essere archiviati',
      duplicate_project: 'Progetto duplicato',
      project_is_archived: 'Questo progetto è archiviato',
      projects_is_api_only: 'Questo progetto è solo API',
      project_is_public: 'Questo progetto è pubblico',
      all_workspace_members: {
        part_of_project: 'Tutti i membri dell\'account fanno parte di questo progetto e {may_not_be_added}.{br}Gli amministratori possono modificare questa impostazione nella scheda "Informazioni".',
        may_not_be_added: 'non possono essere né aggiunti né rimossi'
      },
      last_edit_name_time: 'Ultima modifica di {name} il {time}',
      project_duplicated: 'Progetto duplicato',
      add_my_group: 'Aggiungi il mio gruppo',
      select_a_group: 'Seleziona un gruppo',
      remove_group_from_project: 'Rimuovi il gruppo dal progetto',
      no_group_linked: 'Non ci sono gruppi collegati a questo progetto',
      select_group_to_add: 'Seleziona un gruppo da aggiungere',
      error_while_adding_group: 'Errore durante l\'aggiunta del gruppo',
      budget_recurrence: 'Ricorrenza del budget',
      public_project: 'Progetto pubblico',
      all_workspace_member_are_added: 'Tutti i membri dell\'account vengono aggiunti ai progetti pubblici. Solo i proprietari/amministratori possono impostare i progetti come pubblici.',
      is_billed_per_hour: 'Viene fatturato all\'ora',
      task_management: 'Gestione delle attività',
      enable_task_manager: "Abilita la gestione delle attivit\xE0 per il tuo progetto. Puoi sempre modificarlo in seguito. {br}\n      Nel caso in cui il progetto sia collegato a un'integrazione, le attivit\xE0 verranno importate automaticamente dall'integrazione. {br}\n      Nel caso in cui l'integrazione non supporti l'importazione delle attivit\xE0, questa sezione non sar\xE0 disponibile. {br}",
      enable_task_section: 'Abilita la sezione attività',
      task_are_not_avvaiable: 'Le attività non sono disponibili per {el} progetti al momento specificato.',
      api_lock: 'Blocco API',
      enable_the_api_look: 'Abilita l\'opzione Blocco API se desideri bloccare qualsiasi registrazione/timer su questo progetto.',
      it_may_be_useful: 'Potrebbe essere utile per progetti che devono essere popolati solo da app di terze parti.',
      api_only: 'Solo API',
      only_admin_can_make_project_api_only: 'Solo gli amministratori possono creare solo un\'API di progetto.',
      basic_info: 'Informazioni basilari',
      set_name_an_color: 'Imposta un nome, un colore e una descrizione per il tuo progetto.',
      this_phases_is_linked: 'La fase è collegata a {el} e non può essere modificata.',
      phase_linked_with: 'Fase collegata a {el}',
      edit_tha_phase_name: 'Modifica il nome della fase in {el}',
      there_are_no_phases_linked: 'Non ci sono fasi legate a questo progetto',
      phases_total_budget: 'Budget totale delle fasi',
      the_integration: 'l\'integrazione',
      tags_provide_more_precise_description: "Le etichette forniscono una descrizione pi\xF9 precisa delle tue registrazioni, fungendo da ulteriore metodo di categorizzazione per progetti complessi.\n      Ad ogni registrazione pu\xF2 essere assegnato una o pi\xF9 etichette dall'utente.",
      enter_short_description: 'Inserisci una breve descrizione del progetto',
      add_tags_to_project: 'Aggiungi etichette al progetto',
      archived_last_project: 'Progetto archiviato',
      deleted_project: 'Progetto eliminato',
      delete_phase: 'Elimina fase',
      unarchived_last_project: 'Progetto ripristinato',
      billing__and_budget: 'Fatturazione e budget',
      set_up_client_budget_hourlyrate: 'Imposta un cliente, un budget, una tariffa oraria per il tuo progetto o apri il progetto a tutto il tuo team.',
      only_owner_can_update: 'Solo i proprietari possono aggiornare la fatturazione e il budget su un progetto non fatturabile',
      users_total_budget: 'Budget totale degli utenti'
    },
    projects: {
      search_within_projects: 'Cerca all\'interno dei progetti',
      you_are_about_to_change_client_for_one_project: 'Stai per cambiare cliente per <b>progetto</b>.<br/> Questa azione richiede conferma | Stai per cambiare cliente per <b>{number} progetti</b>.<br/> Questa azione richiede conferma',
      you_are_about_to_edit_one_project: 'Stai per modificare il <b>progetto</b>.<br/> Questa azione richiede conferma | Stai per modificare <b>{number} progetti</b>.<br/> Questa azione richiede conferma',
      you_are_about_to_add_element_into_project: 'Stai per aggiungere a {el} un <b>progetto</b>.<br/> Questa azione richiede conferma | Stai per aggiungere a {el} un <b>{number} progetti</b>.<br/> Questa azione richiede conferma',
      api: 'API',
      add_users_to_all_projects: 'Aggiungi utenti a tutti i progetti selezionati',
      add_phases_to_all_projects: 'Aggiungi fasi a tutti i progetti selezionati',
      add_groups_to_all_projects: 'Aggiungi gruppi a tutti i progetti selezionati',
      number_project_unchanged: 'Un progetto invariato. I progetti demo non possono essere archiviati. | {number} progetti invariati. I progetti demo non possono essere archiviati.',
      set_client: 'Imposta cliente',
      set_client_to_all_projects: 'Imposta il client su tutti i progetti selezionati'
    },
    projectBudgetManagement: {
      only_owner_can_set_monetary_budget: 'Solo i proprietari possono impostare un budget monetario per progetti non fatturabili',
      for_non_billable_projects: 'Per i progetti non fatturabili, nel budget vengono contabilizzati i costi generati dalle registrazioni.',
      also_have_option_set_hourly_rates_from_user: {
        also_have_option_set_hourly_rates: 'FACOLTATIVO: hai anche la possibilità di impostare le tariffe orarie per ciascun membro del team dalla scheda {0}.',
        user: 'Utente'
      },
      also_have_option_set_hourly_rates_from_member_section: 'FACOLTATIVO: hai anche la possibilità di impostare le tariffe orarie per ciascun membro del team dalla sezione Membri.',
      also_have_option_set_time_budgets_per_tag: 'FACOLTATIVO: hai anche la possibilità di impostare budget di tempo per <router-link to="#tags">Etichetta</router-link>, <router-link to="#users">Utente</router-link> o <router-link to="#phases">Fase</router-link> dalle sezioni corrispondenti.',
      also_have_option_set_time_budgets_per: {
        also_have_option: 'FACOLTATIVO: hai anche la possibilità di impostare budget di tempo per {0}, {1} o {2} dalle sezioni corrispondenti.',
        tag: 'Etichetta',
        user: 'Utente',
        phase: 'Fase'
      },
      also_have_option_set_time_budgets_from_corresponding_sections: 'FACOLTATIVO: hai anche la possibilità di impostare budget di tempo per Etichetta, Membro o Fase dalle sezioni corrispondenti.',
      budget_resets_every: 'Il budget viene reimpostato ogni',
      on_up_btn_budget_recurence_weekly: 'il',
      starting_from_up_btn_budget_recurence_monthly: 'il',
      send_email_alert: 'Invia un avviso e-mail se il progetto supera',
      of_budget_after_input_alert_threshold: 'del budget',
      include_expense_in_budget: 'Includere le spese nel calcolo del budget',
      please_note_time_marked: {
        please_note_timers_marked: '{0} registrazioni contrassegnate come "non fatturabili" verranno {1} calcolate nel budget del progetto.',
        time_entries_and_expenses_marked: '{0} registrazioni e spese contrassegnate come "non fatturabili" verranno {1} calcolate nel budget del progetto.',
        please_note: 'NOTA BENE:',
        not: 'non'
      }
    },
    pricingBillingCard: {
      upgrade_your_account: 'Aggiorna il tuo piano e ottieni più funzionalità',
      select_best_plan: 'Seleziona il piano migliore che risponde alla dimensione del tuo team e agli obiettivi aziendali',
      not_ready: {
        downgrade_to: 'Non sei ancora pronto? Passa al nostro {free_plan}',
        free_plan: 'Piano gratuito'
      },
      annual_billing: 'Fatturazione annuale',
      monthly_billing: 'Fatturazione mensile',
      per_time: {},
      per_month: 'per utente/mese',
      billed_monthly: 'con fatturazione mensile',
      billed_yearly: 'fatturato annualmente',
      custom_pricing: 'Prezzi personalizzati',
      up_to_limit_users: 'Fino a {number} utenti',
      unlimited_users: 'Utenti illimitati',
      more_users: 'Hai bisogno di più utenti? {contact}',
      contact_us: 'Contattaci',
      everything_in_plan: 'Tutto nel piano {previous_plan}, più',
      billing_platform: 'Piattaforma di fatturazione',
      start_subscription_for: {
        you_are_about_to: 'Stai per iniziare il tuo abbonamento per {pro}',
        pro_plan: 'Piano Pro'
      },
      what_billing_prefer: 'Quale piattaforma di fatturazione preferisci?',
      microsoft_marketplace: 'Microsoft Marketplace',
      phurchase_subscription: 'Acquista il tuo abbonamento su Microsoft marketplace',
      start_subscription: 'Avvia il tuo abbonamento',
      stripe: 'Stripe',
      use_your_credit_card: 'Utilizza i dati della carta di credito per procedere con il pagamento',
      current_plan: 'Abbonamento corrente',
      subscribe: 'Iscriviti',
      talk_to_sales: 'Parla con le vendite',
      upgrade: 'Upgrade',
      downgrade: 'Downgrade',
      try_plan: 'Prova piano',
      you_want_to_switch: 'Se vuoi passare al Piano Gratuito, devi {archive_users} poiché il Piano {br} Gratuito include solo 2 utenti.',
      you_want_to_downgrade: 'Vuoi passare al Piano Gratuito? {contact_us}',
      archive_number_users: 'archiviare {number} utenti',
      legacy_plan: 'Questo è ora un piano legacy.',
      legacy_plan_description: 'Tutti gli utenti di questo piano manterranno le funzionalità che stanno attualmente utilizzando.<br/>Per un elenco completo delle caratteristiche di questo piano, si rimanda alla tabella sottostante. ',
      switch_to_free: 'Passa al piano gratuito',
      successfully_switched_to_free: 'Hai appena attivato con successo il Piano Gratuito.'
    },
    projectDialog: {
      insert_project_name: 'Inserisci il nome del progetto',
      project_name_required: 'È richiesto un nome di progetto.',
      make_project_public: 'Rendi pubblico il progetto',
      all_workspace_members_added_to_public_projects: 'Tutti i membri dell\'account vengono aggiunti al progetto pubblico',
      chose_members_to_add: 'Scegli i membri da aggiungere',
      invite_new_users: 'Invita nuovi utenti',
      press_enter_to_add_phase: 'premere "invio" per aggiungere una nuova fase',
      created_project: 'Progetto creato',
      general: 'Generale',
      project_details: 'Dettagli del progetto',
      member: 'Membro | Membri',
      project_type: 'Tipo di progetto'
    },
    projectAddUserDialog: {
      add_team_members: 'Aggiungi membri del team',
      user_not_found: 'Utente non trovato',
      all_members_already_in_project: 'Tutti i membri del tuo team fanno già parte di questo progetto',
      search_user: 'Cerca utente',
      to_name: 'a {name}'
    },
    projectArchiveDialog: {
      you_are_about_to_archive_x_projects: 'Stai per archiviare {num_project} progetti',
      will_be_ignored: 'verrà ignorato. I progetti demo non possono essere archiviati.',
      archive_projects: 'Archiviare progetti'
    },
    projectFromTemplateDialog: {
      template: 'Modello',
      new_project_name: 'Nuovo nome del progetto'
    },
    projectUpdateWarningDialog: {
      attention_required: 'Attenzione richiesta',
      deleting: 'Eliminazione',
      all_entries_in_phase: {
        will_be_deleted: 'NOTA BENE: TUTTE le registrazioni in questo {element} verranno eliminate {permanently}.{br}Se non vuoi perdere queste voci, ti consigliamo di spostarle in un\'altra fase prima di salvare o di archiviare invece {element}.',
        permanently: 'permanentemente'
      },
      removing: 'Rimozione',
      member_will_no_longer_track_time: 'Questo membro non sarà più in grado di registrare tempo per questo progetto ma potrà comunque controllare le sue vecchie registrazioni su questo progetto. | Questi membri non saranno più in grado di registrare tempo per questo progetto ma potranno comunque controllare le loro registrazioni su questo progetto.',
      all_members_of_group_no_longer_track_time_on_tag: 'I membri non saranno più in grado di registrare tempo per questa etichetta su questo progetto. | I membri non saranno più in grado di registrare tempo per queste etichette su questo progetto.',
      sum_of_elements_exceeds_projects_budget: {
        sum_of_elements: 'La somma dei budget per membri/fasi/tag supera il budget del progetto.{br}{project_will_be_updated}',
        project_will_be_updated: 'Il budget del progetto verrà aggiornato di conseguenza.'
      },
      confirm_and_save: 'Conferma e salva'
    },
    projectsDeleteDialog: {
      entries_deleted: {
        all_entries_going_to: 'TUTTE le registrazioni su questi progetti {0}.',
        deleted_from_it: 'verranno eliminate'
      },
      sugestion_and_timers_deleted: {
        all_timers_and_sugestion: 'TUTTI i timer e i suggerimenti attualmente collegati a questi progetti {0}.',
        be_deleted: 'sarà cancellato'
      },
      dont_want_to_lose_project: 'Se non vuoi perdere i tuoi dati, ti consigliamo di archiviare questo progetto. | Se non vuoi perdere i tuoi dati, ti consigliamo invece di archiviare questi progetti.',
      delete_projects: 'Elimina progetti'
    },
    projectsInvoiceDialog: {
      billed_money: 'Importo Fatturato',
      total_billable_amount: 'Importo totale fatturabile',
      billed_amount: 'Importo fatturato',
      unbilled_amount: 'Importo non fatturato',
      there_are_invoice: 'Non ci sono fatture per questo progetto.',
      amount_updated: 'Importo aggiornato'
    },
    phasesDialog: {
      serch_within_phases: 'Ricerca all\'interno delle fasi',
      manage_phases_dsa: 'Gestisci fasi'
    },
    phaseDialog: {
      with_name: 'con nome {name}',
      set_all_elements: {
        set_all: 'Imposta tutti i {0} come prima riga',
        categories: 'categorie',
        names: 'nomi'
      },
      bulk_actions: 'Azioni in blocco'
    },
    phaseCategoriesDialog: {
      phase_category_saved: 'Categorie di fase salvate.',
      error_saving_phase: 'Errore durante il salvataggio delle categorie di fase.',
      missing_field_name: 'In uno o più campi manca un nome.',
      phase_category_name: 'Nome della categoria di fase'
    },
    pickerDialog: {
      select_expense_category: 'Seleziona una categoria di spesa',
      select_element: 'Seleziona {el}'
    },
    report: {
      edit_report_name: 'Modifica il nome del report',
      report_scheduled: 'Report programmato. Prossima esecuzione: {el}',
      rounding: 'Arrotondamento',
      round_mode: 'Modalità arrotondamento',
      round_minutes: 'Minuti tondi',
      round_to_up_to: 'Arrotonda per eccesso',
      round_to_nearest: 'Arrotonda al più vicino',
      round_to_down_to: 'Arrotonda per difetto',
      x_minutes: '{el} minuto | {el} minuti',
      x_hour: '{el} ora | {1 ora',
      type_report: '{type_report} report',
      some_data_has_changed: 'Alcuni dati sono cambiati rispetto all\'ultima generazione del report',
      generete_pdf_error: 'Si è verificato un errore durante la generazione del PDF',
      genereting_file: 'Generazione di {el}...',
      as_type_file: 'come file {element}',
      group_by: 'Raggruppa per',
      breakdown_by: 'Suddivisione per',
      ungrouped: 'Non raggruppato',
      untagged: 'Senza etichetta',
      uncategorized: 'Non categorizzato',
      no_todo: 'Nessuna attività',
      no_client: 'Nessun cliente',
      to_open_entries_log: 'Per aprire le registrazioni su una fase è necessario filtrare per un singolo progetto',
      visible_data: 'Dati visibili',
      recurence_resets: {
        resets: '{recurence} si reimposta il {element}',
        recurence: 'Ricorrenza:'
      },
      open_timesheet_dialog: 'Apri nella finestra di dialogo della scheda attività',
      billed_amount: 'Importo fatturato',
      unbilled_amount: 'Importo non fatturato',
      your_roi: {
        your_roi_is: 'Congratulazioni! Il tuo ROI è del {your_roi}% (ROI = (importo fatturato - costi totali) / costi totali x 100)',
        your_current_roi_is: " Il tuo attuale ROI \xE8 {your_roi}% (ROI = (totale fatturato - costi totali) / costi totali x 100){br}\n      Il tuo ROI {estimated} \xE8 {estimate_roi}% (ROI stimato = (totale fatturato + totale_non_fatturato - costi totali) / costi totali x 100)",
        negative_current_roi: "Il tuo attuale ROI \xE8 {your_roi}% (ROI = (totale fatturato - costi totali) / costi totali x 100){br}\n      Il tuo ROI {estimated} \xE8 {estimate_roi}% (ROI stimato = (totale fatturato + totale_non_fatturato - costi totali) / costi totali x 100)",
        estimated: 'Stima'
      },
      open_expenses_page: 'Apri la pagina delle spese',
      internal_costs: 'Costi interni',
      column_disabled_because_no_budget: 'Questa colonna è disabilitata perché il progetto non ha budget. Modifica il progetto per aggiungere un budget',
      project_not_billable: 'Il progetto selezionato non è fatturabile',
      single: 'Singolo',
      cumulative: 'Cumulativo',
      expand_to_see_budgets: 'Espandi per visualizzare i budget',
      your_subscription_dosnt_support: 'Il tuo abbonamento attuale non supporta la gestione dei progetti',
      duplicate: 'Duplica',
      effort: 'Sforzo',
      metric: 'Metrica',
      new_type_report: 'Nuovo report {type}',
      no_data_for_curent: 'Nessun dato per il{br}periodo corrente',
      schedule: 'Programma',
      save_report: 'Salva report',
      from_date_to_date: '<span style="font-size: 10px">dal</span> {date_from} <span style="font-size: 10px">al</span> {to_date}',
      total_expenses: 'Spese totali',
      last_version_support: {
        historical: "L'ultima versione di Timeneye supporta le tariffe storiche.{0}\n          Pertanto, le informazioni finanziarie contenute nelle relazioni dalla versione precedente possono differire dalla nuova versione.{0}{1}",
        learn_more: 'Scopri di più'
      },
      error_while_generating_csv: 'Si è verificato un errore durante la generazione del CSV'
    },
    reports: {
      templates_gallery: 'Galleria dei modelli',
      recent_reports: 'Report recenti',
      scheduled: 'Programmato',
      next_run: 'Prossima esecuzione',
      create_new_report_from: 'Crea un nuovo report da zero',
      monitor_your_project: 'Monitora i tuoi progetti e rispetta il budget',
      get_real_time_insights: 'Ottieni informazioni in tempo reale sull\'impegno del tuo team',
      bill_accurately: 'Fatturazione accurata e consegna puntuale',
      keep_track_of_billable: 'Tieni traccia delle ore fatturabili e non fatturabili',
      dive_deeper: 'Approfondisci i tuoi dati con un report sulle etichette',
      blank: 'Vuoto',
      deleted_report: 'Report eliminato'
    },
    estimateLogDialog: {
      title: 'Storico delle stime',
      no_log_entries: 'Nessuna voce trovata.',
      log_entry: 'Alle {time}, {name} ha {action} la stima del compito:',
      created: 'creato',
      updated: 'modificato',
      edit_task: 'Modifica compito'
    },
    recurrenceSuggestionDeleteDialog: {
      remove_only_this_occurrence: 'Rimuovi solo questa occorrenza',
      disable_recurrent_event: 'Disabilita questo evento ricorrente',
      ignore_recurrent_event: 'Ignora l\'evento ricorrente'
    },
    registerTimeDialog: {
      select_task: 'Seleziona un\'attività',
      entry_created: 'Registrazione creata',
      update_entry: 'Aggiorna registrazione',
      update_timer: 'Aggiorna timer',
      open_link: 'link aperto',
      can_edit_locked_entry: 'Dato il tuo ruolo, puoi modificare questa registrazione',
      edit_entry: 'Modifica',
      new_version: 'Nuova versione'
    },
    setup: {
      welcome_to_timeneye: 'Benvenuti a Timeneye!',
      you_have_been_invited: 'Sei stato invitato a partecipare',
      insert__full_name: 'Inserisci il tuo nome completo',
      min_length_name: 'Il tuo nome completo deve contenere almeno 3 caratteri',
      timeneye_will_monitor_your_progress: 'Timeneye ti aiuterà a monitorare i tuoi progressi, a rispettare il budget e a visualizzare il tuo impegno quotidiano',
      name_your_workspace: 'Dai un nome al tuo account',
      min_length_company_name: 'Il nome dell\'azienda deve contenere almeno 3 caratteri',
      your_primary_role: 'Qual è il tuo ruolo principale?',
      tailor_your_workspace: 'Questo ci aiuterà a personalizzare il tuo account in base alle tue esigenze',
      choose_an_option: 'Scegliere un\'opzione',
      please_choose_option: 'Per favore, scegli un\'opzione',
      how_many_people_working: 'Con quante persone lavorerai?',
      only_me: 'Solo io',
      do_you_use_these_apps: 'Utilizzi qualcuna di queste app?',
      timeneye_can_integrate_with_tool: 'Timeneye può integrarsi perfettamente con il tuo strumento preferito',
      remove_suggestion: 'Rimuovi suggerimento',
      connect_microsoft: 'Collega il tuo account Microsoft a Timeneye',
      this_will_let_you: 'Questo te lo permetterà',
      setting_up_your_workspace: 'Configurare il tuo account',
      redirect_in_dashboard: 'A breve verrai reindirizzato nella dashboard',
      next: 'Avanti',
      grant_permissions: 'Concedi permessi',
      bring_calendar_events: 'Porta gli eventi del tuo calendario nella dashboard di Timeneye per tenere traccia facilmente del tempo delle tue riunioni ed eventi quotidiani.',
      sync_your_to_do: 'Sincronizza i tuoi elenchi di attività con Timeneye per tenere traccia del tempo dedicato alle tue attività lavorative e rimanere organizzato',
      import_ms_planner: 'Importa i tuoi progetti MS Planner in Timeneye e tieni traccia delle tue attività lavorative e monitora i tuoi progressi',
      inser_name_of_company: 'Inserisci il nome della tua azienda',
      owner_has_set_planner: 'Il proprietario dell\'account ha configurato l\'integrazione con MS Planner e tu sei stato incluso automaticamente. Pertanto, è importante mantenere abilitata questa opzione.',
      disabling_option: 'Disabilitando questa opzione perderai la possibilità di tenere traccia del tempo sui progetti importati da MS Planner a Timeneye dal proprietario dell\'account.',
      leave_your_mobile_phone: 'Lascia il tuo numero di cellulare per il supporto all\'onboarding',
      insert_phone: 'Inserisci il tuo telefono',
      job_title_placeholder: 'Ad es. Project Manager, Sviluppatore, CTO',
      workspace_creation: 'Creazione dello spazio di lavoro',
      invite_team_to_timeneye: 'Invita il tuo team a Timeneye',
      garant_permission: 'Concedi l\'autorizzazione',
      install_browser_widgt: 'Installa il widget del browser Timeneye',
      install: 'Installa',
      timeneye_browser: {
        embed_time_tracking: "Il widget del browser Timeneye consente di incorporare i controlli di tracciamento del tempo all'interno dell'interfaccia del software Microsoft preferito, come {integrations}.{br}\n        Questo rende ancora pi\xF9 facile per te e il tuo team compilare accuratamente il foglio ore.",
        integrations: 'MS Planner, MS To Do o Jira'
      },
      import_team_into_timeneye: 'Importa automaticamente i membri del tuo team in Timeneye.{br}Tutto quello che devi fare è concederci l\'autorizzazione per accedere all\'elenco dei membri del tuo team Microsoft.',
      skip: 'Salta',
      number_users: '0 utenti selezionati|1 utente selezionato|{number} utenti selezionati',
      back: 'Indietro'
    },
    listableUsersFromIntegration: {
      invite_users_from_provider: 'Invita utenti da {provider}'
    },
    scheduleReportDialog: {
      schedule_report: 'Programma report',
      report_name: 'Nome del report',
      schedule_every: 'Programma ogni',
      save_schedule: 'Salva programma',
      invalid_email_adress: 'indirizzo email non valido',
      email_already_exist: 'Questo indirizzo email esiste già.',
      press_add_or_enter: 'Premi "Aggiungi" o "Invio" per inserire questo indirizzo email ai destinatari',
      max_10_mails: 'Sono consentite massimo 10 email.',
      send_email_to: 'Invia una email a',
      share_report: {
        you_can_share: "Puoi condividere questo report con un massimo di  {with_10} {br}.\n      Una volta verificati i loro indirizzi email, riceveranno regolarmente questo report.",
        with_10: '10 persone.'
      },
      only_me: 'Solo io',
      me_others: 'Io e gli altri',
      share_with: 'Condividi report con',
      recipient_maximum_warning: {
        to_add_you_have_to_remove: '{0} Per aggiungere più destinatari, devi rimuoverne alcuni.',
        recipient_maximum_capacity: 'L\'elenco dei destinatari ha raggiunto la capacità massima.'
      },
      recipients: 'Destinatari',
      remove_from_recipients: 'Rimuovi membro dai destinatari',
      confirmed: 'Confermato',
      pending: 'In attesa di',
      choosing_this: {
        all_mail_will_be_removed: '{0} Avviso: Scegliendo questa opzione, tutti i destinatari email inseriti precedentemente verranno rimossi dall\'elenco e non riceveranno il tuo report.',
        warning: 'Attenzione'
      }
    },
    sharedEmailDialog: {
      you_have_added_x_pepople: 'Hai aggiunto {number} persone ai tuoi destinatari',
      when_email: {
        verified: "Una volta verificati i loro indirizzi email, riceveranno regolarmente questo report. {br}\n      Questo report \xE8 condiviso con un totale di {total_of_recipients}",
        total_of_recipients: 'totale di {totalRecipientsCount} destinatari.'
      }
    },
    subscriptionTypeUpgrade: {
      upgrade_to: 'Questa funzionalità è inclusa nel ',
      free: 'Piano gratuito',
      starter: 'Piano Starter',
      premium: 'Piano Premium',
      enterprise: 'Piano Enterprise',
      not_owner_message: 'Per accedere a questa funzionalità, devi chiedere al Proprietario dello spazio di lavoro di aggiornare il piano di abbonamento.',
      not_owner: 'Necessaria approvazione del proprietario'
    },
    suggestionsDialog: {
      sugestion_for: 'Suggerimenti per',
      suggestions_ignored: 'Suggerimenti ignorati',
      problem_ignoring_suggestions: 'Si è verificato un problema ignorando uno o più suggerimenti',
      ignore_all: 'Ignora tutto'
    },
    suggestIntegrationDialog: {
      always_open_to_suggestions: 'Qui a Timeneye siamo sempre aperti a suggerimenti per migliorare il nostro prodotto.',
      write_name_of_software: 'Per favore scrivi il nome del software con cui desideri che venga integrato',
      please_write_name: 'Per favore scrivi il nome.',
      send: 'Invia'
    },
    switchEnvironmentDialog: {
      new_version: {
        rewritten: "La vecchia versione di Timeneye sar\xE0 sospesa a partire dal 31 dicembre 2024. {br}\n              Se stai riscontrando problemi di blocco, assicurati di contattarci usando la {support_chat}",
        support_chat: 'chat di supporto'
      },
      let_us_know_why_old_version: 'Fateci sapere perché preferite la vecchia versione. Quanto più dettagliato sarà il tuo feedback, tanto meglio potremo migliorare il nostro prodotto e soddisfare le tue esigenze.',
      prefer_old_version: 'Preferisco la vecchia versione di Timeneye perché...',
      switch_old_version: 'Torna alla vecchia versione'
    },
    switchUserDialog: {
      switch_user: 'Cambia utente'
    },
    tagManagement: {
      select_tag_list: 'Seleziona un gruppo di etichette',
      unarchive_this_tag_list: 'Annulla l\'archiviazione di questo gruppo di etichette per selezionarlo',
      create_a_tag: 'Crea un\'etichetta per selezionare questo gruppo di etichette',
      create_or_unarchive: 'Crea un\'etichetta o annulla l\'archiviazione di una etichetta per selezionarla',
      create_without_adding: 'Crea senza aggiungere',
      tag_list_already_linked: 'Questo gruppo di etichette è già collegato a {el} progetti. </br> Vuoi aggiungere questa etichetta a tutti i progetti collegati?',
      add_tag_to_linked_projects: 'Aggiungi etichetta ai progetti collegati',
      search_within_tag_lists_tags: 'Cerca all\'interno di etichette e gruppi di etichette',
      show_archived_tag_lists_tags: 'Mostra etichette e gruppi di etichette archiviati',
      choose_from_preset: 'Scegli tra i preset',
      select_all_lag_list_tag: 'Seleziona tutte le etichette e gruppi di etichette visibili',
      no_tag_list_matching: 'Non ci sono gruppi di etichette che corrispondono ai filtri.',
      tags_total_budget: 'Budget totale sulle etichette',
      there_are_no_active_tag: 'Non ci sono ancora gruppi di etichette attivi nel tuo account.',
      add_a_new_one: 'Aggiungine uno nuovo',
      open_in_timesheet: 'Apri nell\'elenco registrazioni',
      add_new_tag_list: 'Aggiungi un nuovo gruppo di etichette',
      add_new_tag: 'Aggiungi nuova etichetta',
      add_tag_to_projects: 'Aggiungi etichetta ai progetti',
      archived_last_tag_list: 'Elenco tag archiviato',
      archived_last_tag: 'Etichetta archiviata',
      archive_tag_list: 'Archivia gruppo di etichette',
      archive_tag: 'Archivia etichetta',
      created_last_tag_list: 'Gruppo di etichette creato',
      created_last_tag: 'Etichetta creata',
      delete_tag_list: 'Elimina gruppo di etichette',
      delete_tag: 'Elimina etichetta',
      delete_confirmation_tag_list: 'Vuoi eliminare questo gruppo di etichette?',
      delete_confirmation_tag: 'Vuoi eliminare questa etichetta?',
      edit_tag: 'Modifica etichetta',
      remove_tag_list: 'Rimuovi gruppo di etichette',
      remove_tag: 'Rimuovi etichetta',
      remove_tag_list_from_project: 'Rimuovi gruppo di etichette dal progetto',
      remove_tag_from_project: 'Rimuovi etichetta dal progetto',
      reset_changes: 'Reimposta le modifiche',
      unarchive_tag_list: 'Riattiva gruppo di etichette',
      unarchive_tag: 'Riattiva etichetta',
      updated_last_tag_list: 'Gruppo di etichette aggiornato',
      updated_last_tag: 'Etichetta aggiornata',
      unarchived_last_tag_lsit: 'Gruppo di etichette riattivato',
      unarchived_last_tag: 'Etichetta riattivata',
      save_tag_list: 'Salva gruppo di etichette',
      save_tag: 'Salva etichetta',
      tag_list_confirmation_delete: 'Dopo la conferma, ogni registrazione associata alle etichette in questo gruppo sarà priva di etichette.',
      tag_confirmation_delete: 'Dopo la conferma ogni registrazione associata a questa etichetta ne sarà privata.',
      unarchive_this_tag: 'Ripristina questa etichetta per selezionarla'
    },
    tasks: {
      browser_extension: 'Estensione del browser'
    },
    timers: {
      paused_timers: {
        dont_have_active_paused_timers: 'Non hai timer attivi o in pausa.{br}{click_here}',
        click_here: 'Clicca qui per iniziarne uno nuovo.'
      },
      dont_have_active_or_paused_timers: 'Non hai timer attivi o in pausa'
    },
    todoManagement: {
      sync_data: 'Sincronizza i dati',
      integration_syncing: 'L\'integrazione è in fase di sincronizzazione',
      todo_list_name: 'Nome dell\'elenco delle cose da fare',
      mark_not_completed: 'Contrassegna come non completato',
      mark_as_completed: 'Contrassegna come completato',
      set_due_date: 'Imposta una data di scadenza',
      task_removed: 'Attività rimossa',
      rename: 'Rinomina',
      completed_tasks: 'Attività completate',
      search_within_tasks: 'Cerca all\'interno delle attività',
      add_new_task_list: 'Aggiungi un nuovo elenco di attività',
      create_new_task: 'Crea nuova attività'
    },
    tagListDialog: {
      tag_list_name: 'Nome del gruppo di etichette',
      text_color: 'Colore del testo',
      tag_name: 'Nome dell\'etichetta',
      tag_list_created: '{name} è stato creato',
      add_tag_list: 'Aggiungi gruppo di etichette | Aggiungi gruppi di etichette',
      default: 'Predefinito'
    },
    tagListDeleteDialog: {
      all_tags: {
        going_to_be_deleted: 'TUTTE le etichette all\'interno di questo gruppo verranno immediatamente eliminate e {0} sarà possibile ripristinarli.',
        not: 'non'
      },
      tag_list_deletion: 'Eliminazione del gruppo di etichette',
      you_are_about_to_delete_taglist: 'Stai per eliminare questo gruppo di etichette.',
      taglist_deleted: 'Il gruppo di etichette è stato eliminato'
    },
    tagListPresentsDialog: {
      tag_list_presets: 'Gruppi di etichette predefiniti',
      select_one_of_our_presents: 'Seleziona uno dei nostri gruppi predefiniti per avviare il tuo account.',
      tag_list_with_same_name_already_exist: 'Un gruppo di etichette con lo stesso nome è già presente nell\'account',
      copy_to_workspace: 'Copia nell\'account'
    },
    tagDeleteDialog: {
      tag_deletion: 'Eliminazione etichette'
    },
    tagsDialog: {
      add_selected_tags_to_project: 'Aggiungi le etichette selezionate al progetto'
    },
    todoDialog: {
      to_edit_go_back_to_integration: 'Per apportare modifiche a questa attività, torna a {integration} e modificala da lì. {br} Qualsiasi modifica apportata verrà automaticamente sincronizzata con Timeneye',
      open_in: 'Apri in {name}',
      assign_to: 'Assegnato a',
      select_todo_list: 'Seleziona una lista',
      task_list_required: 'È richiesto un elenco di attività',
      insert_start_date: 'Inserisci la data di inizio',
      insert_due_date: 'Inserisci la data di scadenza',
      insert_task_name: 'Inserisci il nome dell\'attività',
      show_estimate_log: 'Mostra storico',
      manage_task: 'Gestisci attività',
      deleted_task: 'Attività eliminata'
    },
    timersDialog: {
      save_all_as_entries: 'Salva tutti come registrazioni',
      timers_saved: 'Timer salvati',
      problem_occured_while_saving: 'Si è verificato un problema durante il salvataggio dei timer'
    },
    users: {
      invite_from_microsoft: 'Invito da Microsoft',
      invite_from_google_workspace: 'Invito da Google Workspace',
      invite_by_email: 'Invita via e-mail',
      pending: 'In attesa di',
      resend_invite: 'Invia nuovamente l\'invito',
      user_invited_less_than_a_day: 'Questo utente è stato invitato meno di 24 ore fa',
      export: 'Esportare',
      set_members_working_time: 'Imposta l\'orario di lavoro dei membri',
      set_members_hourly_rate: 'Imposta la tariffa oraria dei membri',
      set_members_hourly_cost: 'Imposta il costo orario dei membri',
      set_manager: 'Imposta manager',
      invite_sent: 'Invito inviato',
      error_deactivating_user: 'Errore durante la disattivazione dell\'utente',
      users_activated: 'Utenti attivati',
      error_activating_user: 'Errore durante l\'attivazione dell\'utente.',
      user_in_your_workspace: 'L\'utente è già membro del tuo account',
      user_in_other_workspace: 'L\'utente è già membro di un\'altro account',
      user_already_selected_for_invite: 'L\'utente è già selezionato per l\'invito',
      dep: '- Divisione: {el}',
      search_within_users: 'Cerca tra i membri',
      every: 'Ogni',
      invited_on: 'Invitato su',
      never: 'Mai',
      last_seen_on: 'Visto l\'ultima volta su',
      last_entry_on: 'Ultima registrazione il',
      gm_explain: {
        explain: '{gm} può creare progetti, eseguire {br}funzioni di gestione ed eseguire report, ma solo {br}per i gruppi sotto la sua gestione.',
        gm: 'Gestore del gruppo'
      },
      pm_explain: {
        explain: '{pm} può eseguire funzioni di gestione {br}ed eseguire report, ma solo per i progetti {br}attivi sotto la sua supervisione.',
        pm: 'Responsabile del progetto'
      },
      info_menu_roles: {
        info_owners: '{owners} hanno accesso praticamente a tutte le funzioni {br} e visualizzazioni, inclusa la gestione del pagamento e dell\'abbonamento a {br} e l\'eliminazione dell\'intero account.{br}',
        info_admins: '{admins} dispone di tutte le funzioni del Proprietario {br} tranne la gestione del pagamento e dell\'abbonamento a {br} e l\'eliminazione dell\'account. {br}',
        info_members: '{members} può tenere traccia del tempo e modificare le proprie {br} impostazioni e integrazioni personali.{br}',
        owners: 'Proprietari',
        admins: 'Amministratori',
        members: 'Membri'
      },
      info_menu_manager: {
        info_menu: 'Il responsabile sarà in grado di visualizzare il tempo e le spese di questi utenti. {br} {learn_more}',
        info_menu_approval: 'Il responsabile sarà in grado di approvare o rifiutare i {br} fogli di presenza e le spese di questo utente. {br} {learn_more}',
        learn_more: 'Scopri di più'
      },
      info_menu_hourly_rate: {
        info_menu: 'La tariffa che fatturi ai clienti per il tempo di questa persona.{br} {learn_more}',
        learn_more: 'Scopri di più'
      },
      info_menu_hourly_cost: {
        info_menu: 'Il costo interno sostenuto da questa persona per la tua attività.{br} {learn_more}',
        learn_more: 'Saperne di più'
      },
      you_are_about_to_change_element_to_user: 'Stai per modificare l\'{element} in <b>utente</b>.<br/> Questa azione richiede conferma | Stai per modificare l\'{element} in <b>{number} utente</b>.<br/> Questa azione richiede conferma',
      you_are_about_to_add_user_to_project: 'Stai per aggiungere <b>utente ai progetti</b>.<br/> Questa azione richiede conferma | Stai per aggiungere <b>{number} utenti ai progetti</b>.<br/> Questa azione richiede conferma',
      you_are_about_to_set_manager: 'Stai per <b>assegnare il manager ad 1 utente</b>.<br/> Questa azione richiede conferma | Stai per <b>assegnare il manager a {number} utenti</b>.<br/> Questa azione richiede conferma',
      active_members: 'Membri attivi',
      deactivated_members: 'Membri archiviati',
      set_working_time: 'Imposta orari di lavoro',
      set_working_time_to_all_users: 'Imposta l\'orario di lavoro per tutti gli utenti selezionati',
      set_hourly_rate_to_all_users: 'Imposta la tariffa oraria per tutti gli utenti selezionati',
      set_hourly_cost_to_all_users: 'Imposta il costo orario per tutti gli utenti selezionati',
      set_manager_toltip: 'Assegna un manager a tutti gli utenti selezionati'
    },
    userDialog: {
      add_new_user: 'Aggiungi nuovo utente',
      last_seen: 'Ultima visualizzazione',
      never_logged_in: 'Mai effettuato l\'accesso',
      is_part_of_group: 'Fa parte del gruppo',
      group_managers_cant_be_demoted: 'I manager del gruppo non possono essere retrocessi da project manager se il loro gruppo è nel progetto',
      error_deactiving_user: 'Errore durante la disattivazione dell\'utente.',
      user_activated: 'Utente attivato.',
      error_activating_user: 'Errore durante l\'attivazione dell\'utente.',
      error_deleting_user: 'Errore durante l\'eliminazione dell\'utente.',
      changes_needs_saving: 'Le modifiche devono essere salvate',
      activate: 'Attivare',
      deleted_user: 'Utente eliminato',
      edit_user: 'Modifica utente',
      select_manager: 'Seleziona supervisore'
    },
    userDeleteDialog: {
      all_entries: {
        all_entries_on_user: 'TUTTE le registrazioni tracciate dall\'utente {0}.',
        going_to_be_deleted: 'verranno eliminate'
      },
      all_data: {
        going_to_be_deleted: 'Tutti i dati collegati all\'utente verranno immediatamente cancellati e sarà {0} possibile ripristinarli.',
        not: 'non'
      },
      dont_want_to_lose_user: 'Se non vuoi perdere i tuoi dati, ti consigliamo di archiviare questo utente. | Se non vuoi perdere i tuoi dati, ti consigliamo invece di archiviare questi utenti.',
      user_deletion: 'Cancellazione utente'
    },
    userActivationDialog: {
      you_are_about_to_activate: 'Stai per attivare',
      you_are_about_to_deactivate: 'Stai per disattivare',
      user_deactivation: 'Disattivazione utente',
      user_activation: 'Attivazione utente',
      user_name: '{name} | {number} utenti'
    },
    approvals: {
      title: 'Richieste di approvazione',
      description: 'Il tuo team può inviare i fogli ore e le spese per la revisione, che puoi approvare o rifiutare.',
      approval_period: 'Periodo di approvazione',
      workweek_begin: 'Inizio settimana lavorativa',
      edit_recurrence_start_tooltip: 'Modifica il periodo di inizio ricorrenza',
      manager_tooltip: 'I supervisori possono approvare le spese e i fogli ore degli utenti che gestiscono.',
      minimum_role: 'Chi può approvare le spese e i fogli ore',
      notification_role: 'Chi può ricevere le notifiche',
      recurrence_start: 'Data d\'inizio ricorrenza',
      recurrence_start_option: {
        previous_week: 'Settimana scorsa',
        this_week: 'Questa settimana',
        next_week: 'Settimana prossima',
        previous_month: 'Mese scorso',
        this_month: 'Questo mese',
        next_month: 'Mese prossimo'
      },
      reminders: 'Imposta promemoria',
      send_reminder_after_period_ends: 'Ricorda a tutti d\'inviare i fogli ore e le spese {select} dopo la fine del periodo di approvazione alle {time}.',
      auto_submit_after_period_ends: 'Invia automaticamente i fogli ore e le spese del periodo precedente {select} dopo la fine del periodo di approvazione.',
      auto_approve_after_period_ends: 'Approva automaticamente i fogli ore e le spese inviati {select} dopo la fine del periodo di approvazione.',
      select_members: 'Seleziona utenti',
      no_pending_requests: 'Non ci sono richieste di approvazione in sospeso',
      no_unsubmitted_requests: 'Non ci sono richieste di approvazione da inviare',
      no_approved_requests: 'Non ci sono richieste di approvazione approvate',
      send_email_reminder: 'Invia promemoria per email',
      send_email_reminder_message: 'Stai per inviare un promemoria per email a un utente | Stai per inviare un promemoria per email a {usersCount} utenti',
      email_reminder_sent: 'Promemoria inviato',
      status: {
        pending_approval: 'In attesa di approvazione',
        approved: 'Approvata',
        submitted: 'Inviata',
        unsubmitted: 'Non inviata',
        rejected: 'Rifiutata',
        withdrawn: 'Ritirata',
        action_required: 'Azione richiesta'
      },
      action: {
        send_reminder: 'Invia promemoria per email',
        submit: 'Invia',
        submit_for_approval: 'Invia per l\'approvazione',
        resubmit_for_approval: 'Reinvia per l\'approvazione',
        approve: 'Approva',
        approve_all: 'Approva tutte le richieste',
        reject: 'Rifiuta',
        withdraw: 'Ritira'
      },
      tab: {
        pending: 'In sospeso',
        unsubmitted: 'Non inviate',
        approved: 'Approvate'
      },
      timeline: {
        title_message: '{action} il {date} da {user_name}',
        view_full_history: 'Vedi storico',
        without_notes: 'senza note'
      },
      user_name_timesheet: 'Foglio ore di {user_name}',
      totalsWidget: {
        total_time: 'Tempo totale',
        approved: 'Approvato',
        billable: 'Fatturabile',
        amount: 'Importo',
        expenses: 'Spese'
      },
      select_project: 'Seleziona un progetto',
      remove_project: 'Rimuovi progetto'
    },
    approvalsDialog: {
      title: 'Conferma richiesta di approvazione',
      reject_title: 'Rifiuta richiesta di approvazione',
      withdraw_title: 'Ritira richiesta di approvazione',
      approve_title: 'Approva foglio ore e spese',
      approve_all_title: 'Approva tutti i fogli ore e spese',
      timesheet_submitted: 'Foglio ore inviato per l\'approvazione',
      timesheet_resubmitted: 'Foglio ore reinviato per l\'approvazione',
      timesheet_and_expenses_submitted: 'Foglio ore e spese inviati per l\'approvazione',
      timesheet_and_expenses_resubmitted: 'Foglio ore e spese reinviati per l\'approvazione',
      submit_title: 'Invia per l\'approvazione',
      submit_description: 'Pronto a inviare {0} per l\'approvazione?',
      approve_description: 'Una volta approvato, il tempo sarà bloccato e il foglio ore sarà spostato nella scheda Approvate',
      time: 'Tempo:',
      expenses: 'Spese:',
      add_note: 'Aggiungi nota',
      request_updated: 'Richiesta di approvazione aggiornata'
    },
    approvalTimelineDialog: {
      title: 'Storico'
    },
    workingHours: {
      default: 'Orario di lavoro predefinito',
      reset_default: 'Reimposta orario di lavoro predefinito',
      weekly_total: 'Totale settimanale:'
    },
    workingHoursReminder: {
      reminders_additiona_settings: 'Promemoria e impostazioni aggiuntive',
      send_reminder_email_team: 'Invia un promemoria via email a chi ha tracciato meno di',
      send_reminder_email_user: 'Invia un promemoria email a questo utente se ha tracciato meno di',
      of_their: 'delle loro',
      capacity: 'capacità',
      capacity_on: 'capacità su',
      capacity_on_month: 'capacità nell\'ultimo giorno del mese',
      at: 'alle',
      weekly_capacity: 'Ad es.: Se un utente ha una capacità settimanale di 40 ore e registra meno di 32 ore, riceverà un promemoria via email.',
      daily_capacity: 'Ad es.: Se un utente ha una capacità giornaliera di 8 ore e registra meno di 6,4 ore, riceverà un promemoria via email.',
      monthly_capacity: 'Ad es.: Se un utente ha una capacità mensile di 160 ore e registra meno di 128 ore, riceverà un promemoria via email alla fine del mese.',
      default_reminder_settings: 'Impostazioni predefinite del promemoria'
    },
    workspaceSettings: {
      general_settings: 'Impostazioni generali',
      security: 'Sicurezza',
      features: 'Funzionalità',
      workspace_settings_saved: 'Impostazioni dell\'account salvate',
      chose_image_for_workspace: {
        chose_the: 'Scegli un {image} per il tuo account {el}.',
        image: 'Immagine'
      },
      this_image_is_visible_in: 'Questa immagine è visibile nella maggior parte delle visualizzazioni, in alto a sinistra.',
      workspace_name: 'Nome dell\'account',
      chose_name_for_workspace: {
        chose_the: 'Scegli il {0} che verrà visualizzato per questo account.',
        name: 'nome'
      },
      oirganization_name: 'Nome dell\'organizzazione',
      currency: 'Valuta',
      set_up_curency_and_billable_projects: {
        set_up: 'Configura il {currency_symbol} per i rapporti e le esportazioni di dati nel tuo {billable_projects}.',
        currency_symbol: 'Simbolo di valuta',
        billable_projects: 'progetti fatturabili'
      },
      show_working_time_dashboard: 'Mostra l\'orario di lavoro sulla dashboard',
      let_temmates_see_their_work: 'Consenti ai tuoi compagni di squadra di vedere il loro orario di lavoro nella loro dashboard.',
      labour_cost: 'Costo del lavoro',
      set_up_cost: {
        set_up_avarage_hourly_cost: "Imposta il costo orario medio dei tuoi membri e vedi quanto costano i progetti alla tua azienda.\n      {br}\n      Puoi anche impostarlo per singoli membri dalla  {team_members_view}.",
        team_members_view: 'pagina degli Utenti'
      },
      register_time_for_user: 'Registra il tempo per altri utenti',
      all_admins_on_this_workspace: {
        all_admins: 'Tutti gli amministratori di quest\'account potranno {0} per altri utenti.',
        can_create_entries: 'creare registrazioni'
      },
      enabling_this_feature: {
        enabling_feature: 'Abilitando questa funzione {0} nell\'elenco registrazioni.',
        add_user_option: 'aggiunge un\'opzione utente'
      },
      note_timers_cant_be_started_by_users: 'Nota: i timer non possono essere avviati per altri utenti.',
      // here
      working_hours: {
        title: 'Orario di lavoro',
        description: {
          set_default_working_days: 'Imposta la disponibilità e i giorni lavorativi per gli utenti nel tuo spazio di lavoro.',
          set_individual_working_days: 'Puoi anche impostarlo per singoli membri dalla {0}.',
          team_members_view: 'pagina degli Utenti'
        }
      },
      storage_capacity: {
        title: 'Spazio di archiviazione',
        description: {
          workspace_max_attachments_size: 'Ogni account ha uno spazio massimo disponibile di {0} (licenze pagate) da utilizzare per gli allegati.',
          size_per_user: '{size_in_mb}MB per ogni utente attivo',
          workspace_max_attachments_size_example: 'Ad esempio, se hai 3 licenze a pagamento, lo spazio disponibile è di {totalSize}MB, {regardless} dall\'utente che carica i file.',
          regardless: 'indipendentemente'
        },
        space_used_out_of_max: '{spaceUsed} usato su {maxSize}'
      },
      export_workspace_data: 'Esporta i dati dell\'account',
      export_data_will_generate_csv: 'L\'esportazione dei tuoi dati genererà un file CSV (che puoi aprire con Excel) contenente tutte le registrazioni del tuo account.',
      this_will_be_sent_to_all_admins: 'Questo file verrà inviato a tutti gli indirizzi e-mail degli amministratori dell\'account in pochi minuti.',
      exporting: 'Esportazione...',
      delete_workspace: 'Elimina l\'account',
      once_you_confirm_will_be_deleted: 'Una volta confermato, il tuo account {el} verrà eliminato.',
      evrything_will_be_deleted: 'Tutte le registrazioni, i timer, i progetti, i clienti, gli utenti e qualsiasi altro dato di questo account verranno eliminati.',
      this_is_not_possible_undo_action: 'Tieni presente che NON è possibile annullare questa azione.',
      export_data_before_workspace_deletion: 'Esportare i dati prima della cancellazione dello account (un collegamento al file CSV, valido per 48 ore, verrà inviato a tutti i proprietari dello account)',
      type_delete: 'Digita "{action}"',
      export_request_processed: 'La tua richiesta di esportazione dei dati è in fase di elaborazione, tu (e gli altri amministratori dell\'account) riceverete un file zip nella tua casella di posta entro pochi minuti.',
      account_scheduled_for_deletion: 'È prevista l\'eliminazione del tuo account.',
      error_on_deletion: 'Qualcosa è andato storto.',
      authentication_methods: 'Metodi di autenticazione',
      configure_the_allowed_authentication: 'Configurare i metodi di autenticazione consentiti per l\'account.',
      require_password_or_google_microsoft: 'Richiedi password o accesso a Google/Microsoft',
      require_google_sigin: 'Richiedi l\'accesso a Google per tutti',
      require_microsoft_sigin: 'Richiedi l\'accesso a Microsoft per tutti',
      configure_sso: 'Configura SSO (SAML2.0)',
      require_authentication_saml: 'Richiedi l\'autenticazione tramite SAML2.0',
      saml_endpoint: 'URL dell\'endpoint SAML (ACS)',
      timeneye_endpoint_expecting: 'L\'endpoint Timeneye attende il payload di autenticazione da un provider di identificazione SAML.',
      issuer_id: 'ID dell\'emittente',
      the_entity_id: 'L\'ID entità del provider di identità.',
      login_url: 'URL di accesso (IDP)',
      the_url_used: 'L\'URL utilizzato per accedere al provider di identità SAML.',
      x509_certificate: 'Certificato X.509',
      the_signing_key: 'La chiave di firma del provider di identità SAML.',
      allow_username_password_auth: 'Consenti l\'accesso tramite nome utente/password',
      turn_off_when_completed_testing_login: 'Disattiva questa opzione una volta completato il test di accesso tramite il tuo provider di identità.',
      download_sp_metadata: 'Scarica metadati SP',
      allow_third_party_apps: 'Consenti app di terze parti',
      enable_disable_possibility_to_auth_third_party: 'Abilita/disabilita la possibilità di autorizzare app di sviluppatori di terze parti per gli utenti dell\'account.',
      downloading_metadata: 'Download dei metadati in corso...',
      entries_lock: 'Blocco delle registrazioni',
      select_date_to_lock_all_entries: 'Seleziona una data in cui bloccare tutte le registrazioni.',
      after_enabling_this: {
        after_enabling_all_entries: 'Dopo aver abilitato questa impostazione, tutte le registrazioni e i timer in sospeso/attivi {0} periodicamente in base alla ricorrenza selezionata.',
        will_be_locked: 'verrà automaticamente bloccato'
      },
      all_entry_will_still_be_visible: 'Tutte le registrazioni bloccate saranno ancora visibili, ma gli utenti non saranno in grado di aggiungere o modificare registrazioni prima dell\'ultima data di blocco.',
      note_entry_lock_procesed_at_midnight: 'Nota: il blocco verrà elaborato alla mezzanotte del tuo fuso orario.',
      type_valid_day: 'Si prega di digitare un numero di giorno valido',
      last_locked_date: 'Ultima data bloccata',
      expense_management: 'Gestione delle spese',
      monitor_expenses: {
        monitor_in_timeneye: 'Monitora {0} in Timeneye e assegnali a progetti, utenti e clienti specifici.',
        expeses: 'spese'
      },
      from_to_title: 'Vista cronologica',
      from_to_description: 'Mostra tutte le voci di tempo con gli orari della giornata chiaramente indicati (ad esempio dalle 09:00 alle 10:00) nel dashboard.',
      bill_clients: 'Fatturare i clienti in modo accurato e calcolare la redditività del progetto.',
      after_activating_a_new_section_will_appear: {
        after_activating: 'Dopo aver attivato questa funzione, una nuova sezione per le {expenses} apparirà nel menu principale, così come una sezione {expense_categories} nel tuo {workspace_settings}.',
        expenses: 'spese',
        expense_categories: 'Categorie di spesa',
        workspace_settings: 'Impostazioni dell\'account'
      },
      project_management: 'Gestione del progetto',
      manage_and_track_time_on_task: {
        manage_and_track_time: 'Gestisci e monitora il tempo sul tuo {0} direttamente in Timeneye.',
        tasks: 'attività'
      },
      after_activating_this: {
        after_activating_a_new_tab_will_appear: 'Dopo aver attivato questa funzione, verrà visualizzata una nuova scheda {0} nei Dettagli del progetto, dopo aver abilitato le attività per quel progetto dalla pagina di modifica del progetto.',
        tasks: 'attività'
      },
      custom_report_logo: 'Logo personalizzato per il report',
      chose_custom_image: {
        chose_custom: 'Scegli un {0} personalizzato per i tuoi rapporti.',
        image: 'Immagine'
      },
      this_image_will_be_shown: 'Questa immagine verrà mostrata nell\'angolo in alto a destra dei tuoi report PDF.',
      remove_logo: 'Rimuovi logo',
      select_image_from_device: 'Rilascia la tua immagine o fai clic qui per selezionarla dal tuo dispositivo',
      logo_should_be: 'Le proporzioni del logo dovrebbero essere 4:1 (ad esempio 400px x 100px)',
      maximum_uploade_size: 'Dimensione massima di caricamento 2M (jpg, jpeg, png, bmp)',
      drop_your_image_anywhere: 'Rilascia la tua immagine ovunque o fai clic qui per selezionarla dal tuo dispositivo',
      max_upload_size: 'Dimensione massima caricamento 2M (jpg, jpeg, png, bmp, svg, webp)',
      required_fields: 'Campi obbligatori',
      required_fields_description: 'Assicurati di impostare determinati campi come obbligatori per tutti gli utenti nel tuo workspace. Questo impedisce ai membri del team di dimenticare informazioni importanti e garantisce coerenza in tutte le registrazioni.',
      required_fields_entry_notes: 'L\'aggiunta di {notes} è necessaria quando si crea una registrazione',
      required_fields_notes: 'Note',
      required_fields_expense_project: 'Selezionare un {project} è necessario quando si crea una spesa',
      required_fields_project: 'Progetto'
    }
  },
  layouts: {
    timesheet: 'Scheda attività',
    trial_ended: 'PROVA FINITA',
    trial_left: 'PROVA {el} rimasta | PROVA {el} rimasta',
    subscription_expired: 'ABBONAMENTO SCADUTO',
    grace_period: 'PERIODO DI GRAZIA: {number} giorno rimasto | PERIODO DI GRAZIA: {number} giorni rimasti',
    plan_billing: 'Pianificazione e fatturazione',
    profile: 'Profilo',
    product_updates: 'Aggiornamenti del prodotto',
    developers_portal: 'Portale degli sviluppatori',
    logout_all_profiles: 'Disconnettersi da tutti i profili',
    user_profile: 'Profilo utente',
    collapse_menu: 'Comprimi il menu',
    expand_menu: 'Espandi il menu'
  },
  pages: {
    billing: {
      current_plan: 'Abbonamento corrente:',
      trial_flag: 'Prova',
      plan_pricing_details: "${monthlyPrice}/utente/mese se pagato mensilmente, o ${yearlyPrice}/utente/mese se pagato annualmente.",
      plan_expiration: 'Scadenza:',
      trial_plan_expiration: 'Scadenza della prova:',
      microsoft_marketplace_description: 'Acquista il tuo abbonamento su Microsoft marketplace',
      stripe_description: 'Utilizza i dati della carta di credito per procedere con il pagamento',
      plan_selection_action: 'Avvia il tuo abbonamento',
      manage_microsoft_licenses_action: 'Gestisci la tua licenza su Microsoft Marketplace.',
      licenses_number: 'Numero di licenze: {licensesNumber}',
      days_left: {
        you_have_x_days: 'Ti rimangono {number_days} giorni del tuo {trial}',
        number_days: '{number} GIORNI',
        free_trial: 'prova gratuita.'
      },
      number_active_licenses: '{number} licenze attive',
      upgrade_plan: 'Piano di aggiornamento',
      manage_licenses: 'Gestisci licenze',
      manage_subscription: 'Gestisci il tuo abbonamento',
      next_renewal: 'Prossima scadenza: {date}',
      renewal_information: 'INFORMAZIONI SUL RINNOVO',
      no_active_subscription: 'Non hai alcun abbonamento attivo. La tua scadenza attualmente è {date}.',
      current_payment_is: 'Il tuo abbonamento {duration} è di {price} USD, con un totale di {limit_user} licenze.',
      monthly_duration: 'mensile',
      yearly_duration: 'annuale',
      billing_history: 'Storia della fatturazione',
      see_full_plan: 'Visualizza il confronto completo dei piani',
      invoices: 'Fatture',
      billing_date: 'Data di fatturazione',
      please_suscribe: '{is_expired} Per favore inizia il tuo abbonamento per continuare a utilizzare Timeneye',
      is_expired: 'Il tuo abbonamento a Timeneye è scaduto.',
      start_subscription: 'Avvia il tuo abbonamento',
      licenses_updated: 'Il numero di licenze è stato aggiornato',
      need_payment_confirmation: 'È necessario confermare il pagamento per procedere',
      confirm_payment: 'Conferma il pagamento'
    },
    automation_settings: 'Impostazioni di automazione',
    you_cant_access_your_biling_status: 'Non puoi accedere alle informazioni di fatturazione da Microsoft Teams.',
    click_here_to_change_settings: 'Fai clic qui per modificare le impostazioni di fatturazione su Timeneye.',
    developers_panel: 'Pannello degli sviluppatori',
    create_and_manage_your_applications: 'Crea e gestisci le tue applicazioni per dare ai tuoi utenti l\'accesso alle API Timeneye.',
    how_to_get_started: 'Come iniziare',
    applications: 'Applicazioni',
    no_apps_created: 'Nessuna app creata',
    create_new_app: 'Crea una nuova app',
    delete_app: 'Elimina l\'app',
    delete_app_confirmation: 'Sei sicuro di voler eliminare l\'app {app_name}?',
    app_deleted: 'Applicazione eliminata.',
    email_verification: 'Verifica email',
    enter_code_you_recived: 'Inserisci il codice che hai ricevuto via email per verificare il tuo indirizzo email.',
    verify_email: 'Verifica Email',
    verifying_email: 'Verifica e-mail...',
    go_back_to_login: 'Torna al modulo di accesso',
    invalid_recaptcha: 'Recapcha non valido',
    the_code_not_valid: 'Il codice non è valido',
    error_message: {
      message: 'Mi spiace, non c\'è niente qui...{0}',
      error: '(404)'
    },
    go_back: 'Torna indietro',
    saml_sign_on: 'Accesso singolo SAML',
    use_email_that_matches_sso: 'Utilizza l\'e-mail che corrisponde alle tue credenziali SSO.',
    forgot_your_password: 'Hai dimenticato la password?',
    sign_with_microsoft: 'Accedi con Microsoft',
    sign_with_google: 'Accedi con Google',
    sign_with_saml: 'Accedi con SAML SSO',
    other_ways_to_sign_in: 'Altri modi per accedere',
    dont_have_workspace: 'Non hai uno account?',
    error_during_authentication: 'Si è verificato un problema durante l\'autenticazione',
    fail_log_in: 'Impossibile accedere. L\'e-mail e/o la password potrebbero mancare.',
    confirm_password: 'Conferma la tua password',
    your_password_has_been_chenged: 'La tua password è stata modificata. {br}Ora puoi accedere con le tue nuove credenziali.',
    enter_your_email_for_reset: 'Inserisci il tuo indirizzo email e ti invieremo le istruzioni su come reimpostare la password.',
    type_your_email: 'Digita il tuo indirizzo email',
    send_reset_instructions: 'Inviami le istruzioni per il ripristino',
    sending_reset_instructions: 'Invio istruzioni di ripristino...',
    you_should_recive_an_email: 'Dovresti ricevere un\'e-mail con il link per il ripristino entro pochi secondi.',
    if_dont_recive_it: 'Se non ricevi una nostra email entro pochi minuti, assicurati di controllare il filtro antispam.',
    trusted_by: 'Scelto da oltre 800 aziende in 50 paesi',
    sign_up_for_free: 'Iscriviti gratis',
    join_timeneye_for_free: 'Unisciti a Timeneye gratuitamente.',
    no_credit_card_needed: 'Non è necessaria alcuna carta di credito.',
    by_signing_up_i_agree: {
      by_signing: 'Iscrivendomi, accetto i nostri {privacy_policy} e {terms_of_service}',
      privacy_policy: 'Politica sulla riservatezza',
      terms_of_service: 'Termini di servizio'
    },
    continue_sign_up: 'Continua la registrazione qui',
    open_with_teams: 'Apri in Microsoft Teams',
    sign_up_with_microsoft: 'Iscriviti con Microsoft',
    sign_up_with_email: 'Iscriviti con la tua email',
    min_length_name: 'Il tuo nome completo deve contenere almeno 3 caratteri',
    email_required: 'L\'e-mail è obbligatoria',
    work_email: 'Posta elettronica di lavoro',
    or_sign_up_with: 'Oppure registrati con',
    aleardy_have_an_account_sign_in: {
      aleardy_have_an_account: 'Hai già un account?{0}',
      sig_in: 'Accedi'
    },
    track_your_projects_in_timeneye: 'Tieni traccia dei tuoi progetti in Timeneye e aumenta la tua produttività',
    manage_projects: 'Gestisci progetti:',
    track_time_on_project: 'Tieni traccia del tempo del ciclo di vita del tuo progetto, tieni d\'occhio i budget e rimani in contatto con il tuo team.',
    report_analyze: 'Segnala e analizza:',
    create_visual_report: 'creare un report visivo per analizzare la produttività e fare stime migliori per il futuro.',
    accurate_billing: 'Fatturazione accurata:',
    deliver_billable_minute: 'consegna in tempo e acquisisci ogni minuto fatturabile lavorato dall\'intero team.',
    subscription_expired: 'Abbonamento scaduto',
    your_timeneye_subscription_expired: 'Il tuo abbonamento a Timeneye è scaduto.',
    contact_your_workspace: {
      workspace_owners: 'proprietari dell\'account',
      contact_your_workspace_owner_expired: 'Contatta il tuo {workspace_owners} per rinnovare l\'abbonamento {br} e continuare a utilizzare Timeneye.',
      contact_your_workspace_owner_trial_ended: 'Contatta il tuo {workspace_owners} per passare a un piano a pagamento {br} e continuare a utilizzare Timeneye.',
      contact_your_workspace_owner_unauthorized: 'Contatta il tuo {workspace_owners} per continuare a utilizzare Timeneye.'
    },
    trial_ended: 'Il processo è terminato',
    your_timeneye_trial_expired: 'La tua prova Timeneye è terminata.',
    unauthorized: 'Non autorizzato',
    your_timeneye_user_has_been_disabled: 'Il tuo utente Timeneye è stato disabilitato da un amministratore.',
    go_to_login_page: 'Vai alla pagina di accesso',
    new_password: 'Nuova password',
    or: 'O',
    // between 2 buttons
    authenticating: 'Autenticazione di {integrationName}...'
  },
  mixins: {
    your_calendar_has_been_updated: 'Il tuo calendario è stato aggiornato',
    failed_to_link_integration: 'Impossibile collegare l\'integrazione.',
    failed_to_get_integration: 'Impossibile ottenere l\'integrazione.',
    error_during_authentication: 'Si è verificato un problema durante l\'autenticazione',
    billable_time: 'Tempo fatturabile',
    not_billable_time: 'Tempo non fatturabile',
    billed_money: 'Importo Fatturato',
    billable_money: 'Importo fatturabile',
    total_money: 'Importo totale',
    total_cost: 'Costo totale',
    billed_cost: 'Costo fatturato',
    unbilled_cost: 'Costo non fatturato',
    total_profit: 'Profitto totale',
    total_unbilled: 'Totale non fatturato',
    billed_profit: 'Profitto fatturato',
    unbilled_profit: 'Profitto non fatturato',
    favorite: 'Preferito',
    column_disable_if: 'Questa colonna è disabilitata se sono selezionati più progetti o se il progetto non ha budget.',
    invitation_status: 'Stato dell\'invito',
    labor_cost: 'Costo del lavoro',
    locked_status: 'Stato bloccato',
    locked: 'Bloccato',
    billing_status: 'Stato di fatturazione',
    total_expenses: 'Spese totali',
    unit_price: 'Prezzo unitario',
    task_list: 'Elenco delle attività',
    source: 'Fonte',
    progress: 'Progresso',
    todo: 'Attività',
    billed_fixed_fee: 'Tariffa fissa fatturata',
    unbilled_fixed_fee: 'Tariffa fissa non fatturata',
    billed_money_info: 'Importo fatturato = manodopera fatturata + spese fatturate + tariffa fissa fatturata',
    total_cost_info: 'Costi totali = costo del lavoro + spese totali',
    billed_labor: 'Manodopera fatturata',
    unbilled_labor: 'Manodopera non fatturata'
  },
  notificationPanel: {
    general: 'Generale',
    announcements: 'Annunci'
  },
  app: {
    session_expired: 'La tua sessione è scaduta. Effettua nuovamente l\'accesso per continuare.',
    go_to_project: 'Vai al progetto',
    go_to_integration: 'Vai all\'integrazione',
    sidebar: {
      show: 'Mostra barra laterale',
      collapse: 'Comprimi la barra laterale',
      unpin: 'Sblocca',
      pin: 'Blocca',
      register_time: 'Registra',
      dashboard: 'Bacheca',
      dashboard_short: 'Bacheca',
      expenses: 'Spese',
      entries_log: 'Elenco registrazioni',
      entries_log_short: 'Registrazioni',
      team: 'Utenti',
      projects: 'Progetti',
      clients: 'Clienti',
      reports: 'Report',
      tasks: 'Attività',
      timesheet: 'Foglio ore',
      approvals: 'Approvazioni',
      integrations: 'Integrazioni',
      data_management: 'Gestione dei dati',
      data_management_short: 'Gestione',
      tags: 'Etichette',
      phase_categories: 'Categorie delle fasi',
      expense_categories: 'Categorie di spese',
      import_data: 'Importa dati',
      settings: 'Impostazioni',
      subscription: 'Abbonamento',
      notifications: 'Notifiche',
      support: 'Supporto',
      help_center: 'Centro assistenza',
      tutorial_videos: 'Video tutorial',
      product_updates: 'Aggiornamenti del prodotto',
      feature_request: 'Richiedi una funzionalità',
      developers_portal: 'Portale degli sviluppatori',
      contact_support: 'Contatta il supporto',
      subscription_expired: 'ABBONAMENTO SCADUTO',
      x_day_left: '{number} giorno rimasto | {number} giorni rimasti',
      personal_settings: 'Impostazioni personali',
      switch_account: 'Cambia utente',
      switch_bach_to_old_version: 'Torna alla vecchia versione',
      new_version_avaiable: 'Nuova versione disponibile!',
      click_here_to_update: 'Clicca per aggiornare',
      logout: 'Esci | Esci da tutti i profili'
    }
  },
  boot: {
    can_only_see_track_edit: 'Può solo vedere, tenere traccia e modificare i propri timer e registrazioni',
    can_see_track_edit: 'Può vedere, tenere traccia e modificare i timer e le registrazioni di chiunque nel team',
    it_is_admin: 'È un amministratore ma può gestire i dettagli di fatturazione ed eliminare l\'account'
  }
};